export default {
    "corporate": "Bedrijfsprogramma",
    "onboarding": {
        "goal_desc": "U verdient %{customPoints} voor het volgen van uw activiteit en bonus %{customPoints} voor het behalen van uw doelen. Het is tijd om te beginnen! u kan op elk moment 3 persoonlijke doelen actief hebben.",
        "sample_task": {
            "modalActivityTitle": "3 keer diep ademhalen",
            "rewards_featured_title": "Aanbevolen",
            "rewards_partners_title": "Partners",
            "header_description": "U verdient %{customPoints} door uw activiteit bij te houden en taken, doelen en uitdagingen te voltooien.",
            "icon_text": "Tap op het {icon} om een diepe ademhaling te volgen.",
            "activityName": "diepe ademhaling",
            "activityUnit": "adem"
        },
        "lets_get_started": "Laten we beginnen!",
        "start_description": "U verdient %{customPoints} door uw activiteit bij te houden en taken, doelen en uitdagingen te voltooien.",
        "complete_and_earn": "Voltooi en verdien",
        "did_it": "Ik heb het gedaan!",
        "task_complete": "Taak volbracht!",
        "breath_sample_task": "Volg een korte tutorial over het volgen van activiteiten",
        "track_a_sample_activity": "Volg een voorbeeldactiviteit",
        "nice": "Leuk!",
        "nice_one": "Goed zo!",
        "nice_subtext_1": "U hebt %{points} %{customPoints} verdiend.",
        "nice_subtext_2": "Door %{customPoints} te verdienen, kan u een hoger niveau bereiken. Elke keer dat u een niveau omhoog gaat, verdien u %{reward_currency}, die u kan inwisselen voor geweldige aanbiedingen.",
        "nice_subtext_3": "U verdient meer punten als u meer taken voltooit, activiteiten bijhoudt en doelen en uitdagingen voltooit.",
        "progress_subtitle": "Uw %{customPoints} en vooruitgang worden elke %{frequency} gereset.",
        "skip_for_now": "Sla over voor nu",
        "loadingText": "Een moment terwijl we uw welzijnsscore berekenen.",
        "goal_title": "Stel een persoonlijk doel in",
        "swipe_for_more": "Veeg om meer te zien",
        "skip_goals": "Ik ben klaar met doelen stellen voor nu.",
        "complete_profile": "",
        "level": "Niveau",
        "finish_onboarding_action": "Voltooi eerst de onboarding",
        "vital_stats": {
            "height_ft": "Lengte vt.",
            "height_in": "Hoogte in."
        },
        "rewards": "",
        "welcome": {
            "disclaimerTitle": "Uw privacy is belangrijk"
        },
        "levels": {
            "title": "Prestaties en beloningen",
            "tableTitle": "Prestatie"
        },
        "initialScreen": {
            "title": "Welkom bij %{programName}, %{username}!",
            "getRewarded": "Word beloond met %{rewardName}",
            "completeAgainst": "Concureer met u collega's",
            "earnPoints": "Verdien punten met wellnessactiviteiten",
            "levelUp": "Ga een niveau omhoog en ontgrendel badges"
        },
        "starterGoals": {
            "title": "Selecteer een doel",
            "subtitle": "Begin uw welzijnsreis met een nieuwe gezonde gewoonte."
        }
    },
    "healthkit_not_available": "Kan geen verbinding maken met Apple Gezondheid. Zorg ervoor dat u in de Gezondheid-app onder Bronnen minimaal toestemming hebt voor stappen en dat er ten minste 1 stap wordt gevolgd.",
    "changeCover": "Verander foto",
    "joiningCommunityToast": {
        "success": {
            "message": "u bent succesvol lid geworden van %{name}",
            "title": "Word lid van community"
        }
    },
    "achievement_starts_date": "Begint: %{date}",
    "editChallenge": "%{challengeName} bewerken",
    "createChallenge": {
        "activitiesOrCategory": {
            "subtitle": "Kies maximaal 5 activiteiten",
            "title": "Wat zou u willen doen?",
            "noActivityTitle": "Activiteiten toevoegen",
            "noActivityMessage": "Selecteer minimaal één activiteit of categorie.",
            "categoryItemDescription": "Alle activiteiten in categorie %{category}",
            "addActivityTitle": "Hoeveel %{unit} van %{activity} wil u doen per %{period}?",
            "addCategoryQuantityTitle": "Hoeveel %{customPoints} wil u verdienen in de categorie %{category}?",
            "subtitleCategories": "Selecteer één categorie. Alle activiteiten uit die categorie dragen bij aan het doel.",
            "subtitleWithActivities": "%{num} van %{max} activiteiten geselecteerd",
            "selectCategoryMessage": "Alle activiteiten in de categorie worden geselecteerd en de eerder geselecteerde activiteiten worden verwijderd.",
            "addActivityTitleTotal": "Hoeveel %{activity} wil u doen in %{period}?"
        },
        "inviteDepartments": {
            "title": "Afdelingen\/divisie uitnodigen"
        },
        "inviteRegions": {
            "title": "Regio's uitnodigen"
        },
        "createInvitation": {
            "selectMore": "Selecteer ten minste 2 %{entity}s!"
        },
        "visibility": {
            "title": "Zichtbaarheid",
            "description": "Teamuitdagingen kunnen worden gevonden en kunnen worden gevolgd door alle %{programName} gebruikers."
        },
        "highest": {
            "name": "De meeste %{customPoints} overwinningen",
            "description": "Geen limieten, hoogste %{customPoints} staat op de 1e plaats"
        },
        "compete": {
            "individual": "Concureren als een individu",
            "team": "Concureren als een team"
        },
        "unitType": {
            "title": "Selecteer hoe u uw doel voltooit",
            "subtitle": "Kies uit activiteiten of een categorie"
        },
        "category": {
            "name": "Alle activiteiten in een categorie",
            "description": "Volg bijvoorbeeld elke activiteit in 'Bewegen'",
            "title": "Selecteer een categorie",
            "subtitle": "Van welke categorie gaat u activiteiten volgen?"
        },
        "activities": {
            "name": "Geselecteerde activiteiten",
            "description": "Bijv. Volg specifieke activiteiten zoals fietsen",
            "title": "Selecteer activiteiten",
            "subtitle": "We raden aan om u te concentreren op één activiteit, maar u kan er maximaal 5 toevoegen",
            "maxModalTitle": "Maximale activiteiten geselecteerd",
            "maxModalDescription": "U kan maximaal 5 activiteiten toevoegen. Tap op Accepteren om verder te gaan met u 5 geselecteerde activiteiten of op Bewerken om wijzigingen aan te brengen.",
            "warningModalTitle": "Hoge moeilijkheidsgraad",
            "warningModalDescription": "U hebt in dit doel veel activiteiten opgegeven die per periode moeten worden voltooid. Weet u zeker dat u zo'n uitdagend doel wilt stellen?",
            "requiredPoints": "vereist om te voldoen aan %{period} %{challengeType}",
            "noActivitiesModalTitle": "Activiteiten toevoegen",
            "noActivitiesModalDescription": "Selecteer minimaal één activiteit."
        },
        "categoryQuantity": {
            "title": "Stel uw %{customPoints} doel in",
            "subtitle": "Hoeveel %{customPoints} wil u verdienen van %{category} elke %{period}?",
            "subtitleTotal": "Hoeveel %{customPoints} wil u verdienen met %{category} %{period}?",
            "text": "Als richtlijn is 30 minuten gematigde activiteit gelijk aan ongeveer 105 %{customPoints}",
            "noQuantityModalTitle": "Hoeveelheid",
            "noQuantityModalDescription": "Voer een waarde in",
            "defaultCategoryTitle": "huidige categorie"
        },
        "cancel": {
            "title": "Maken van uitdaging annuleren",
            "message": "Weet u zeker dat u het maken van een uitdaging wilt annuleren?"
        },
        "createNew": "Maak een nieuwe uitdaging",
        "chooseChallengeTitle": "Selecteer een uitdaging of maak er zelf een",
        "createOwn": {
            "title": "Maak mijn eigen"
        },
        "frequency": {
            "title": "Hoe vaak ga u uw doel halen?",
            "subtitle": "Dagelijkse doelen zijn geweldige gewoontebouwers"
        },
        "startAndDuration": {
            "title": "Kies een begindatum en duur",
            "subtitle": "",
            "noFieldsTitle": "Begindatum en duur",
            "noFieldsMessage": "Vul begindatum en duur in"
        },
        "finalize": {
            "title": "Bekijk u nieuwe doel",
            "subtitle": "",
            "noFieldsTitle": "Naam en instructies",
            "noFieldsMessage": "Vul naam en instructies in",
            "name": "Mijn %{frequency} %{names} doel",
            "instructionCategory": "Verdien %{points} %{customPoints} %{frequency} met alle %{category} activiteiten",
            "instructionActivities": "Volg %{items} %{frequency} en verdien %{points} %{customPoints} %{pointsFrequency}",
            "instructionCompetitionCategory": "Haal het meeste %{customPoints} uit alle %{category} activiteiten om deze wedstrijd te winnen",
            "instructionCompetitionActivities": "Haal de meeste %{customPoints} van %{items} om deze wedstrijd te winnen",
            "namePlaceholder": "Geef u competitie een naam",
            "titleChallenge": "Voltooi u uitdaging"
        },
        "dailyDescription": "Bijv. Elke dag 8 glazen water drinken",
        "weeklyDescription": "Bijv. 150 minuten per week wandelen",
        "monthlyDescription": "Bijv. 150 km per maand rennen",
        "totalDescription": "Bijv. In totaal 10.000 km fietsen",
        "title": "Uzelf of anderen uitdagen?",
        "navigatorTitle": "Maak een uitdaging aan",
        "me": {
            "name": "Alleen ik",
            "description": "Daag uzelf uit met een persoonlijk doel"
        },
        "others": {
            "name": "Concurreer met anderen",
            "description": "Concurreer individueel of als team"
        },
        "one": {
            "name": "Individueel",
            "description": "Voltooi individueel met andere gebruikers"
        },
        "team": {
            "name": "Als een team",
            "description": "Voltooi als een team met andere teams"
        },
        "company": {
            "name": "Bedrijfsuitdaging",
            "description": "Maak een speciale competitie"
        },
        "adminItemTitle": "Als beheerder kan u maken",
        "userOrTeamTitle": "Individueel of als team strijden?",
        "target": {
            "name": "Stel een doel in om te halen",
            "description": "Uitdaging die een bovenlimiet heeft"
        },
        "typeTitle": "Selecteer een %{challengeType}-type",
        "teamSizeTitle": "Selecteer een grootte voor elk team",
        "teamSizeSubtitle": "De minimale grootte van een team is %{min} en de maximale grootte is %{max}. De %{customPoints} van uw team zijn het gemiddelde van alle leden in het team en u kan alleen %{customPoints} verdienen wanneer uw team het minimum aantal leden heeft bereikt.",
        "teamSize": {
            "noFieldsTitle": "Min en max",
            "noFieldsMessage": "Selecteer het minimum en maximum aantal leden van een team"
        },
        "companyChallengeTitle": "Bedrijfsuitdaging",
        "companyChallengeSubtitle": "U bent een beheerder. U kan afdelings- en andere soorten uitdagingen instellen",
        "chooseDepartmentTitle": "Kies afdelingen \/ divisies om te concureren",
        "chooseRegionTitle": "Kies regio's om te concureren",
        "goToChallenge": "Ga naar mijn uitdaging",
        "additional": {
            "title": "Uitdaging aangemaakt",
            "subtitle": "Laten we beginnen! Nodig anderen uit om mee te doen.",
            "makePublicName": "Maak dit openbaar",
            "makePublicDescription": "Iedereen kan meedoen",
            "toDirectoryName": "Indienen bij de Challenge Directory",
            "toDirectoryDescription": "Mensen kunnen er zo een maken",
            "inviteTitle": "Nodig uit om uit te dagen",
            "titleGoal": "Doel gemaakt!"
        },
        "quantityMinimum": {
            "message": "De minimaal vereiste hoeveelheid is %{quantity}",
            "title": "Onvoldoende hoeveelheid"
        },
        "toast": {
            "success": "Uw %{challengeType} is gemaakt."
        },
        "goToGoal": "Ga naar mijn doel",
        "navigatorTitleGoal": "Maak een doel",
        "quantityError": {
            "wholeNumber": "Moet een geheel getal zijn",
            "greaterThanZero": "Moet groter zijn dan 0"
        }
    },
    "wellbeing": {
        "description": {
            "overall": "Uw welzijnsscore wordt berekend door de antwoorden die u in de welzijnsenquête heeft gegeven te vergelijken met die van miljoenen andere mensen in dezelfde leeftijds- en geslachtscategorie als u. Uw score laat zien welke positie u inneemt ten opzichte van hen. Uw score wordt elke maand automatisch bijgewerkt op basis van veranderingen in u beweeg-, eet- en voelgedrag die in de app zijn ingevoerd. Consistent doelen stellen en positieve actie ondernemen om uw gezondheid te verbeteren, kan helpen om uw welzijnsscore te verbeteren.",
            "excellent": "Uw gezondheidsscore is beter dan 85% van de mensen van uw leeftijd en geslacht.",
            "very_good": "Uw gezondheidsscore is beter dan 70-84% van de mensen van uw leeftijd en geslacht.",
            "good": "Uw gezondheidsscore is beter dan 51-69% van de mensen van uw leeftijd en geslacht.",
            "fair": "Uw gezondheidsscore is beter dan 31-50% van de mensen van uw leeftijd en geslacht.",
            "poor": "Uw gezondheidsscore is lager dan 70% van de mensen van uw leeftijd en geslacht. Het is nooit te laat om prioriteit te geven aan uw gezondheid. Profiteer van ons platform om u te helpen vooruitgang te boeken op uw wellnessreis!",
            "overall_result": "Over het algemeen is uw welzijnsscore %{status}.",
            "category_result": "Over het algemeen is uw {category}-score {string}.",
            "goals": "Zonder doelpunten win u niet. Stel maximaal 3 persoonlijke doelen in en volg deze. Als u na verloop van tijd uw levensstijl verandert, ziet u uw score stijgen."
        },
        "reminder": {
            "title": "Het is tijd om uw welzijnsenquête bij te werken!",
            "updateAnswers": "Werk mijn antwoorden bij"
        },
        "lastUpdated": "Laatst bijgewerkt %{date}",
        "scoreDescription": {
            "part1": "u score is",
            "part2": "score van",
            "belowAverage": "onder het gemiddelde",
            "aboveAverage": "boven het gemiddelde",
            "part3": "voor anderen van uw leeftijd en geslacht."
        },
        "improveScore": {
            "description": "Uw score wordt berekend op basis van uw antwoorden op de welzijnsenquête en bijgehouden activiteiten. U kan uw enquêteantwoorden bijwerken of nieuwe doelen stellen om te verbeteren.",
            "desc1": "Veel hoger kan uw score niet! Om uw routines interessant te houden, daag uzelf uit met doelen die net buiten u normale vermogens liggen, en nodig anderen uit om met u te concureren om gemotiveerd te blijven.",
            "desc2": "Als u klaar bent om een niveau omhoog te gaan, is het tijd om de uitdaging te vergroten. Daag uzelf uit met doelen die net buiten u normale vermogens liggen, en nodig anderen uit om met u te concureren om gemotiveerd te blijven.",
            "desc3": "Stel persoonlijke doelen en maak openbare uitdagingen om uzelf verantwoordelijk te houden en de motivatie te behouden. Zorg ervoor dat u haalbare doelen en kleinere tijdsbestekken kiest - we raden 1 week aan.",
            "desc4": "Het is belangrijk om elke dag actief te zijn. Als u niet veel beweging hebt in u dagelijkse routine, begin dan met kleine doelen die passen bij u vemogens en interesses. Zorg ervoor dat u haalbare doelen en kleinere tijdsbestekken kiest - we raden 1 week aan."
        },
        "recommendedGoals": "Aanbevolen doelen",
        "recommendedDescription": {
            "desc1": "Stel in op",
            "desc2": "3 doelpunten",
            "desc3": "om u te concentreren op het verbeteren van uw welzijn. u hebt momenteel"
        },
        "categoryScore": "Uw %{category}-score is",
        "learnMore": "Kom meer te weten",
        "youAreSet": "U bent klaar!",
        "goalSetting": "Doelstelling",
        "attention": "%{category} score niet beschikbaar.",
        "move": {
            "error": "Op basis van uw antwoorden is uw bewegingscore niet beschikbaar."
        },
        "eat": {
            "error": "U hebt aangegeven dat een zorgverlener u heeft verteld dat u diabetes type 2 hebt en dat dit niet onder controle is."
        },
        "feel": {
            "error": "Op basis van uw antwoorden is uw gevoelsscore niet beschikbaar."
        },
        "survey": {
            "requiredField": "* dit veld is verplicht"
        },
        "score_info_title": "Wat mijn score betekent",
        "company_average_info": "Gemiddeld bij mijn bedrijf",
        "demographic_average_info": "Gemiddeld in mijn demografie",
        "score": "Welzijnscore",
        "table": {
            "what_it_means": "Wat het betekent",
            "score": "Score"
        },
        "updated": "Bijgewerkt",
        "label": {
            "excellent": "Uitstekend",
            "very_good": "Heel goed",
            "good": "Goed",
            "fair": "Redelijk",
            "poor": "Slecht"
        },
        "activity": {
            "eat": "Eet Activiteit 1, Eet Activiteit 2, Eet Activiteit 3",
            "move": "Beweeg Activiteit 1, Beweeg Activiteit 2, Beweeg Activiteit 3",
            "feel": "Voel Activiteit 1, Voel Activiteit 2, Voel Activiteit 3"
        },
        "score_info_screen": "Hoe wordt mijn score berekend?",
        "details": "Details",
        "activities": "Activiteiten",
        "improveCategoryScore": "Verbeter mijn %{category} score",
        "meaning": {
            "heading": "Score berekening"
        },
        "score_button": {
            "meaning": "Wat betekent deze score?"
        },
        "improve": "Zie aanbevolen doelen",
        "score_text": {
            "demographic": "De gemiddelde score voor uw leeftijd en geslacht is",
            "company": "en de gemiddelde score bij uw bedrijf is"
        },
        "scoreHigher": "hoger dan het gemiddelde van",
        "scoreLower": "lager dan het gemiddelde van",
        "settedGoals": {
            "noGoals": "Geen doelen ingesteld",
            "one": "1 doel ingesteld",
            "n": "%{count} doelen ingesteld"
        },
        "yourScoreIsPoor": "Uw %{category}-score is slecht",
        "unlock": {
            "title": "Ontgrendel uw welzijnsscore",
            "description": "Vul een korte vragenlijst in om erachter te komen hoe uw algehele gezondheid zich verhoudt tot die van andere mensen in uw demografie."
        },
        "browseAndSet": "U kan bladeren en nieuwe doelen stellen nadat uw huidige zijn voltooid.",
        "excellent": {
            "desc1": "Uitzonderlijk gezonde levensstijl",
            "desc2": "Zeer laag gezondheidsrisico"
        },
        "veryGood": {
            "desc1": "Zeer gezonde levensstijl",
            "desc2": "Laag gezondheidsrisico"
        },
        "good": {
            "desc1": "Gezonde levensstijl",
            "desc2": "Gemiddeld gezondheidsrisico"
        },
        "fair": {
            "desc1": "Redelijk gezonde levensstijl",
            "desc2": "Bovengemiddeld gezondheidsrisico"
        },
        "poor": {
            "desc1": "Hoog gezondheidsrisico",
            "desc2": "Meer dagelijkse beweging is aan te raden",
            "desc3": "Meer dagelijkse beweging is nodig"
        },
        "calculateScore": {
            "description": "Wanneer u de welzijnsenquête invult, worden uw antwoorden geanalyseerd met behulp van miljarden gegevensvariabelen van mensen van uw leeftijd en geslacht. De berekening houdt ook rekening met de activiteit die u volgt in %{programName}.\n \n  Uw welzijnsscore wordt regelmatig bijgewerkt, zodat u deze in de loop van de tijd kan zien veranderen."
        },
        "improveYourScore": "Uw score verbeteren"
    },
    "challengerCount": "%{num} uitdagers",
    "team_name": "Teamnaam",
    "syncingDeviceToast": {
        "danger": {
            "message": "Oeps... We hadden een probleem met het synchroniseren van %{name}. Probeer het opnieuw.",
            "title": "Synchroniseren"
        },
        "success": {
            "title": "Synchroniseren",
            "message": "Succesvol gesynchroniseerd %{name}. Uw activiteiten zijn nu up-to-date."
        }
    },
    "allCompanyMembers": "Alle bedrijfsleden",
    "allCompanyMembersTeam": "Alle bedrijfsleden (Team)",
    "successfullyRedeemedItemForConfirmation": "U heeft dit item succesvol ingewisseld en er is een bevestigingsmail verzonden naar %{email}.",
    "no_all_events_placeholder": "Het lijkt erop dat er op dit moment geen evenementen beschikbaar zijn om aan deel te nemen. Maak een?",
    "confirmDeleteAccount": "Bevestig de verwijdering door het e-mailadres in te voeren dat aan uw account is gekoppeld",
    "deleteAccount": "Account verwijderen",
    "linkAccounts": "Beheer gekoppelde accounts",
    "titleSlug": {
        "icon_reward_text": "Het is gemakkelijk voor in aanmerking komende leden om meer punten te verdienen door te winkelen bij onze partners of tijdens een controle bij een tandarts met Member's Choice Advantage met hun extra dekking.",
        "icon_move_text": "Door dagelijkse gezonde keuzes te volgen, zoals beter slapen of groenten eten, kan u Live Better-punten verdienen.",
        "icon_redeem_text": "Live Better beloont Medibank-leden die een ziekenhuis- of aanvullende dekking hebben om voor hun gezondheid te zorgen.",
        "icon_phone_text": "Meld u aan en ga op weg om beloningen in te wisselen, zoals cadeaubonnen voor gezondheid en welzijn of om te besparen op uw ziektekostenverzekering.",
        "wellness": "Welkom in de wereld van wellness",
        "goals": "Bereik u doelen",
        "devices": "Op koers blijven",
        "challenges": "Maak uitdagingen",
        "celebrate": "Sociale wellness",
        "habits": "Bouw gezonde gewoontes op",
        "joinChallenge": "Doe mee aan de uitdaging",
        "getSocial": "Wordt sociaal",
        "reward": "Word beloond voor een gezonder leven.",
        "move": "Beweeg, eet & voel u beter.",
        "phone": "Leef beter, voel u beter."
    },
    "viewProgress": {
        "goal": "Doelvooruitgang bekijken",
        "challenge": "Bekijk de vooruitgang van de uitdaging",
        "progress": "Bekijk de vooruitgang"
    },
    "vitalStats": {
        "disclaimer": {
            "message": "Het invoeren van deze informatie is optioneel, voor uw eigen voordeel en privé voor u."
        }
    },
    "eventBonusPoints": {
        "section": {
            "title": "%{potentialBonusPoints} bonus %{customPoints} zijn beschikbaar voor dit evenement!"
        },
        "modal": {
            "paragraph1": "Door deel te nemen aan dit evenement verdien u bonus %{pointsName}.",
            "paragraph2": "Alle bonus %{pointsName} wordt toegekend nadat het evenement is voltooid. U ontvangt geen bonuspunten voor evenementen die u niet bijwoont."
        }
    },
    "EAP": {
        "contactInfo": "Contactgegevens",
        "doLater": "Ik doe dit later",
        "tellMore": "Vertel me meer",
        "contactMe": "Neem contact met mij op",
        "title": "Programma voor werknemers- en gezinsbijstand",
        "reachGoal": {
            "title": "Er is hulp beschikbaar",
            "description": "Uw Programma voor werknemers- en gezinsbijstand (EFAP), aangeboden door %{providerName}, biedt een verscheidenheid aan gezondheidscoachingservices om u te helpen uw welzijnsdoelen te bereiken.\n \n  Wilt u dat %{providerName} contact met u opneemt voor meer informatie?"
        },
        "privacyPolicy": "%{provider} Privacybeleid"
    },
    "HRIS": {
        "disclaimer": "Deze informatie wordt automatisch ingesteld en kan niet worden gewijzigd"
    },
    "settingGoals": {
        "description": "Door u te concentreren op 3 aanbevolen doelen tegelijk, vergroot u de kans op succes.",
        "title": {
            "one": "U hebt 1 doel ingesteld"
        }
    },
    "auth": {
        "linkAccount": {
            "alreadyLinkedToUser": "Account al gekoppeld aan een andere gebruiker",
            "lastAccountMessage": "Weet u zeker dat u uw laatst gekoppelde account wilt verwijderen? Als het verwijderd is moet u inloggen met e-mailadres %{email} en een nieuw wachtwoord.",
            "unlinkCorpAccountMessage": "Weet u zeker dat u uw zakelijke gekoppelde account wilt verwijderen? Als het verwijderd is moet u opnieuw inloggen met e-mailadres %{email}.",
            "alreadyLinked": "Account al gekoppeld",
            "unlinkMessage": "Weet u zeker dat u een gekoppeld account wilt verwijderen?"
        },
        "sso": {
            "emailNotVerified": "Uw e-mailadres is niet geverifieerd."
        },
        "signIn": {
            "dontHaveAccount": "Heb u geen account?",
            "enterPIN": "Voer uw bedrijfsprogramma-identificatienummer in",
            "dontKnowPIN": "Weet u uw pincode niet?",
            "pin": "PIN",
            "register": "Registreren",
            "pinDescription": "Neem contact op met uw programmabeheerder als u niet zeker bent van het unieke programma-identificatienummer (PIN) van uw organisatie. Als u een pincode hebt en problemen hebt om door te gaan naar de volgende stap, neem dan contact op met support@sproutatwork.com.",
            "keepMeTooltip": "Als dit vakje is aangevinkt, blijft uw sessie voor uw gemak 30 dagen geldig. Op gedeelde apparaten raden we u aan dit vakje uit te vinken en uit te loggen als u klaar bent."
        },
        "signUp": {
            "backToLogin": "Terug naar Inloggen",
            "termsOfService": "Servicevoorwaarden",
            "privacyPolicy": "Privacybeleid"
        },
        "createYourAccount": "Maak je account aan",
        "setYourDetails": "Stel je gegevens in",
        "ModaHybridLogin": {
            "noAccessDashboard": "Heb je geen toegang tot het ledendashboard?",
            "signUpSSOButton": "Meld je aan via het Moda Member Dashboard",
            "noAccessDashboardWeb": "Als u geen toegang hebt tot het ledenoverzicht, log dan hieronder in met uw e-mailadres en wachtwoord.",
            "loginSSOButton": "Inloggen via Moda Member Dashboard"
        }
    },
    "entityHasBeenDeleted": "%{name} is verwijderd",
    "track_challenge": {
        "message": {
            "manually": "Volg handmatig",
            "automatically": "Automatisch bijgehouden met %{appOrDeviceName}",
            "manuallyOrConnect": "Volg handmatig of verbind een app of apparaat",
            "manuallyAndBy": "Volg handmatig en automatisch met %{appOrDeviceName}",
            "reconnectDevice": "Apparaat vereist. Maak opnieuw verbinding met uw apparaat",
            "manualAndAuto": "Volg handmatig en automatisch",
            "trackedAutomatically": "Automatisch gevolgd"
        }
    },
    "signUpPartnerSSOToast": {
        "danger": {
            "title": "Kan niet aanmelden",
            "message": "Kan gebruikersgegevens van partner niet ophalen. Probeer het later opnieuw"
        }
    },
    "app_device_required": {
        "disclaimer": {
            "title": "Voor deze %{goalName} is een app of apparaat vereist.",
            "subTitle": "Verbind een app of apparaat"
        }
    },
    "descriptionSlug": {
        "wellness": "Word lid van de gezondheidscommunity die u helpt doelen te stellen, verbinding te maken en op koers te blijven.",
        "goals": "Vertel ons waar u naartoe werkt. We helpen u daar te komen met aanbevolen doelen.",
        "devices": "Synchroniseer uw fitnessapparaat of registreer uw activiteiten en houd uw wellnessdoelen op koers.",
        "challenges": "Roep een vriendschappelijke wedstrijd op. Maak een uitdaging en nodig anderen uit om mee te doen.",
        "celebrate": "Blijf in contact met collega's en vier samen u successen.",
        "habits": "Volg wellnessactiviteiten om punten te verdienen. Link naar u telefoon of wearable om sneller te verdienen.",
        "joinChallenge": "Kijk hoe u het doet ten opzichte van u collega's in vriendschappelijke competities.",
        "getSocial": "Blijf in contact met collega's en vier samen uw successen.",
        "reward_text": "Verdien punten voor het voltooien van dagelijkse activiteiten en persoonlijke uitdagingen.",
        "move_text": "Of het nu gaat om een blokje om, vijf minuten mindfulness of gezond eten, u wordt beloond.",
        "phone_text": "Gebruik uw punten voor kortingen op uw dekking en geweldige aanbiedingen, de keuze is aan u.",
        "none": ""
    },
    "core": {
        "featureNotEnabled": "Functie niet ingeschakeld",
        "checkAppVersion": {
            "message": "Het lijkt erop dat u app verouderd is. Installeer de nieuwste update.",
            "button": "Update %{appName}"
        },
        "noConnection": {
            "title": "Geen netwerkverbinding",
            "description": "Het lijkt erop dat u geen verbinding hebt met internet. U kan de applicatie niet volledig gebruiken, tenzij u een verbinding maken.",
            "button": "Probeer het opnieuw"
        },
        "uploadPhotoText": "Voeg een foto toe voor uw %{entityType}",
        "entities": {
            "community": "community",
            "event": "evenement",
            "team": "team",
            "goal": "doel",
            "challenge": "uitdaging",
            "competition": "concurrentie"
        }
    },
    "registration": {
        "login": {
            "errorHeading": "Niet mogelijk om in te loggen",
            "resetPasswordHeading": "Wachtwoord opnieuw instellen vereist"
        },
        "signup": {
            "corporateOrOther": "Geen Medibank-lid? Of onderdeel van een bedrijfsprogramma?",
            "sign_up_here": "Registreer hier",
            "errorHeading": "Kan niet aanmelden",
            "areYouMedibankMember": "Ben u Medibank-lid?",
            "isMedibankMember": "Ik ben lid",
            "isNotMedibankMember": "Ik ben geen lid"
        },
        "bpidExists": "Het opgegeven e-mailadres is al gekoppeld aan een Live Better-gebruiker, het e-mailadres moet uniek zijn.",
        "generalError": "Service momenteel niet beschikbaar"
    },
    "rewardsNoAvailableProducts": "Er zijn op dit moment geen beschikbare producten.",
    "endedGoal": {
        "timeToTrack": {
            "yes": "U hebt nog tijd om te volgen!",
            "no": "Uw %{type} is afgelopen"
        },
        "grace": "Uw %{type} is misschien afgelopen, maar u hebt %{n} %{text} om eventuele vergeten activiteiten te volgen",
        "notGrace": {
            "goal": "Gefeliciteerd met het behalen van u doel! Ga zo door met het geweldige werk door een nieuw doel te stellen om opkoers te blijven met uw welzijn.",
            "competition": "Gefeliciteerd met het voltooien van de uitdaging! Houd het momentum vast door mee te doen aan een andere uitdaging of u eigen uitdaging te creëren."
        }
    },
    "appDeviceModal": {
        "defaultMessage": "Verbind uw apparaat of app en geniet van eenvoudig volgen. Dankzij uw authenticatie kan onze technologiepartner \"Sprout\" uw gegevens veilig overdragen van uw %{appDeviceTitle}-account."
    },
    "noTransactionsMessage": "Het lijkt erop dat u geen transacties heeft uitgevoerd.",
    "noRedemptionsMessage": "Het lijkt erop dat u nog geen inwisselingen hebt gedaan.",
    "challengeCarousel": {
        "emptyChallenge": {
            "subtitle": "U kan als individu of als team de uitdaging aangaan",
            "prompt": "Er zijn momenteel geen uitdagingen om aan mee te doen. Waarom maakt u er geen?"
        },
        "createChallengeButton": "Maak een uitdaging"
    },
    "eventCarousel": {
        "emptyEvents": {
            "subtitle": "Evenementen kunnen alleen op uitnodiging zijn of toegankelijk voor iedereen.",
            "button": "Maak een evenement aan"
        },
        "emptyEventsMessage": "Er zijn momenteel geen evenementen om aan deel te nemen. Waarom maakt u er geen?"
    },
    "appnameLiveBetter": "Leef beter",
    "appnameTelus": "Welzijn",
    "appnameUPnGo": "UPnGO",
    "personal_goal": {
        "carousel": {
            "headingNoSet": "U hebt geen doelen gesteld!",
            "descriptionNoSet": "Verbeter uw welzijnsscore door enkele doelen te stellen. Ga snel aan de slag met een aanbevolen doel, kies uit de catalogus of maak u eigen doel.",
            "descriptionSet": "U kan een van de aanbevolen doelen instellen die we speciaal voor u hebben, door de volledige catalogus bladeren of uw eigen doel maken.",
            "action_text": "Stel een nieuw doel",
            "heading_singular": "U kan nog 1 doel instellen",
            "heading_plural": "U kan nog %{number} doelen stellen"
        },
        "heading": "Persoonlijke doelen",
        "single": "Persoonlijk doel"
    },
    "settingGoal": {
        "yourGoal": "Uw %{units}",
        "yourGoalDescription": "U bent onderweg! De volgende %{units} worden ingesteld en beginnen meteen.",
        "selectedGoals": "Geselecteerde doelen",
        "recommendedDescription": {
            "maximumSet": "U hebt het maximale aantal doelen ingesteld. U kan bladeren en nieuwe doelen stellen nadat uw huidige zijn voltooid.",
            "maximumSetTitle": "U hebt %{count} doelen ingesteld"
        }
    },
    "activityLogRemoved": {
        "single": {
            "success": "De activiteit is verwijderd",
            "info": "Er is iets fout gegaan. Probeer het opnieuw.",
            "danger": "Er is iets fout gegaan. Probeer het opnieuw."
        },
        "plural": {
            "success": "Activiteiten zijn verwijderd",
            "info": "Er is iets fout gegaan. Probeer het opnieuw.",
            "danger": "Er is iets fout gegaan. Probeer het opnieuw."
        },
        "success": "De activiteit is verwijderd",
        "info": "De activiteit is niet verwijderd. Probeer het opnieuw.",
        "danger": "De activiteit is niet verwijderd. Probeer het opnieuw."
    },
    "participants": "Deelnemers",
    "members": "Lid \/ Leden",
    "timeSittingInformationOld": "Richtlijnen: \n - Minimaliseer de hoeveelheid tijd die wordt doorgebracht in langdurig zitten. \n - Onderbreek langdurig zitten zo vaak mogelijk.",
    "timeSittingInformation": {
        "title": "Richtlijnen:",
        "list": "- Minimaliseer de hoeveelheid tijd die wordt doorgebracht in langdurig zitten. \n - Onderbreek langdurig zitten zo vaak mogelijk."
    },
    "activityLevelInformationOld": "Richtlijnen: \n - Actief zijn op de meeste, bij voorkeur alle, dagen per week. \n - Verzamel elke week meer dan 150 minuten matig intensieve lichamelijke activiteit. \n - Doe minimaal 2 dagen per week spierversterkende activiteiten.",
    "activityLevelInformation": {
        "title": "Richtlijnen:",
        "list": "- Actief zijn op de meeste, bij voorkeur alle, dagen per week. \n - Verzamel elke week meer dan 150 minuten matig intensieve lichamelijke activiteit. \n - Doe minimaal 2 dagen per week spierversterkende activiteiten."
    },
    "viewGuidelines": "Bekijk richtlijnen",
    "corporateAccountLink": {
        "verification": {
            "title": "Verifieer uw bedriifs e-mailadres",
            "description": "U moet uw bedriifs e-mailadres verifiëren om het koppelingsproces te voltooien. Volg de instructies die zijn verzonden naar:"
        }
    },
    "invitation": {
        "findFriendsAndFamily": "Vind vrienden en familie",
        "findFriends&Family": "Vind vrienden en familie",
        "tapToAddFriendsAndFamily": "Tap om toe te voegen aan vrienden en familie",
        "addedFriendsAndFamily": "Toegevoegd aan vrienden en familie",
        "whoYouAreLookingFor": "Zie u niet wie u zoekt?",
        "inviteWithEmail": "Uitnodigen met e-mail",
        "sentInvitations": "Verzonden uitnodigingen",
        "foundPerson": "We hebben deze persoon gevonden met een overeenkomend e-mailadres",
        "youAreBoth": "Jullie zijn allebei in %{entityName}",
        "youAreBothMore": "Jullie zijn allebei in %{entityName}, +%{n} meer",
        "noFriendsAndFamilyAdded": "Het lijkt erop dat u nog geen vrienden of familie hebt toegevoegd.",
        "sendInvitation": "Verstuur uitnodiging",
        "youHaveNoSentInvitations": "U heeft geen uitnodigingen verzonden",
        "toast": {
            "success_title": "Uitnodiging verzonden",
            "success_description": "%{invite_email} ziet de uitnodiging in hun inbox",
            "danger_title": "Uitnodiging is niet gelukt",
            "danger_description": "Probeer het later opnieuw"
        },
        "email": {
            "invalid_email": "Voer een geldig e-mailadres in"
        },
        "inviteOthers": "Nodig anderen uit",
        "searchForSomeone": "Zoek iemand",
        "searchForOthersToInvite": "Zoek naar anderen om alleen",
        "programNameOnly": {
            "title": "naar %{programName} uit te nodigen",
            "description": "Deze %{entityType} is alleen beschikbaar voor mensen die deel uitmaken van %{programName}"
        },
        "domainCannotBeUsed": "Dit domein kan niet worden gebruikt met %{programName}",
        "actionSearchByEmail": "Nodig per e-mail uit als u niet kan vinden wie u zoekt",
        "send": "Versturen",
        "addEmailToList": "E-mail toevoegen aan de lijst",
        "toBeSent": "Uitnodigingen worden verzonden",
        "noInvitationsToBeSent": "Geen uitnodigingen",
        "removeEmailConfirmation": "Weet u zeker dat u deze e-mail van de lijst wilt verwijderen?",
        "yes": "Ja",
        "no": "Nee",
        "foundByEmail": "We hebben deze persoon gevonden met een overeenkomend e-mailadres",
        "addToFriendsAndFamily": "Toevoegen aan vrienden en familie",
        "alreadyAddedEmail": "U hebt dit e-mailadres al aan de lijst toegevoegd"
    },
    "pointsCurrencyAdditionalInfo": "Uw %{points_name} en niveaus beginnen elke %{period} opnieuw. Al uw bijgehouden activiteiten dragen bij aan uw algehele niveau in de periode.",
    "rankLabel": "Rang",
    "leaderboards": {
        "loadingLabel": "Leaderboards laden... Dit kan enkele minuten duren - het lijkt erop dat iedereen actief aan het worden is!"
    },
    "feeds": {
        "emptyListHomePage": "Er zijn nog geen berichten om weer te geven. Probeer de stream aan te passen om meer berichten te tonen.",
        "viewingPostsFrom": "Posts bekijken van",
        "postActivity": "Voeg een reactie of foto toe over uw activiteiten!",
        "indicatorLoader": {
            "defaultTitle": "Vernieuwen…",
            "successfulLoadedTitle": "Gesynchroniseerd en vernieuwd..."
        },
        "inapropriateTextError": {
            "message": "De inhoud van uw bericht is mogelijk ongepast. Probeer schonere taal te gebruiken."
        },
        "postImageError": {
            "title": "Sorry, we kunnen dit niet posten",
            "message": "De afbeelding die u hebt toegevoegd, is mogelijk ongepast. Probeer een andere afbeelding."
        }
    },
    "syncModal": {
        "connect": {
            "title": "%{name} verbinden",
            "description": "Voer de volgende stappen uit om uw %{name}-gegevens aan uw account te koppelen:",
            "firstStep": "Download en installeer de %{appName} mobiele applicatie vanuit de %{storeName}",
            "fourthStep": "Selecteer om verbinding te maken met %{name}",
            "fifthStep": "Selecteer desgevraagd de gezondheidsstatistieken die u wilt synchroniseren met %{appName} en druk op 'Gereed'",
            "additionalInfo": "Houd er rekening mee dat %{appName} geopend moet zijn om synchronisatie vanuit de Gezondheid-app te activeren. Hoewel u de app niet geopend hoeft te houden, kan het een uur duren voordat de synchronisatie is voltooid en in uw activiteitenlogboek wordt weergegeven."
        },
        "title": "%{name} synchroniseren",
        "description": "Voer de volgende stappen uit om uw %{name}-gegevens met uw account te synchroniseren:",
        "steps": {
            "one": "Meld u aan bij uw %{appName}-app op uw mobiel",
            "two": "Open het gedeelte Apps & Apparaten in uw profiel",
            "three": "Druk op de synchronisatieknop naast %{name}",
            "iPhone": "Meld u aan bij uw %{appName}-app op uw iPhone"
        }
    },
    "accountLinkingToast": {
        "success": {
            "title": "Bedrijfsaccount",
            "message": "Account succesvol verbonden"
        },
        "danger": {
            "message": "Fout bij koppelen van account"
        },
        "conflict": {
            "message": "Account is al gekoppeld aan een andere gebruiker"
        }
    },
    "accountUnlinkingToast": {
        "success": {
            "title": "Bedrijfsaccount",
            "message": "Account succesvol ontkoppeld"
        },
        "danger": {
            "title": "Accounts koppelen",
            "message": "Fout bij ontkoppelen van account"
        }
    },
    "earnMoreWithPartners": "Verdien meer met partners",
    "connectPartnersToEarnByShopping": "Koppel uw accounts en verdien meer %{unit_type} door te winkelen bij %{program_name} partners.",
    "viewAllPartners": "Bekijk alle partners",
    "myPartnerMemberships": "Mijn partnerlidmaatschappen",
    "linkAccount": "Lidmaatschap koppelen",
    "linkToPartner": "Link naar partner",
    "linkingError": "Er is een probleem opgetreden bij het koppelen van uw account. Probeer het opnieuw.",
    "linkPending": "Link in afwachting",
    "unlinkAccount": "Account ontkoppelen",
    "linkedToPartnerName": "Gekoppeld aan %{partner_name}",
    "linked": "Gekoppeld",
    "permission": {
        "facebookTitle": "Aanmelden met Facebook",
        "googleTitle": "Aanmelden met Google",
        "facebookDescription": "Wanneer u zich aanmeldt met Facebook, moet u onze technologiepartner \"Sprout\" toestemming geven om toegang te krijgen tot uw identiteit en uw %{programName}-account aan te maken.",
        "googleDescription": "Wanneer u zich aanmeldt met Google, moet u onze technologiepartner \"Sprout\" toestemming geven om toegang te krijgen tot uw identiteit en uw %{programName}-account te maken.",
        "camera": {
            "title": "Camera-toegang",
            "description": "Toegang tot de camera is vereist om een foto te maken. Tap in de iPhone-instellingen op %{appName} en schakel Camera in.\n \n Houd er rekening mee dat u niet-opgeslaan wijzigingen kan verliezen."
        },
        "notNow": "Niet nu",
        "openSettings": "Open instellingen",
        "photos": {
            "title": "Geef toegang tot foto's",
            "description": "Hiermee kan u foto's uit u bibliotheek delen en foto's opslaan op u camerarol. Tap in de iPhone-instellingen op %{appName} en stel Foto's in op Lezen en schrijven.\n \n Houd er rekening mee dat u niet-opgeslaan wijzigingen kan verliezen."
        }
    },
    "firstNameContainsSpecialChar": "Uw voornaam mag alleen Nederlandse letters, koppeltekens - en apostrofs bevatten",
    "lastNameContainsSpecialChar": "Uw achternaam mag alleen Nederlandse letters, koppeltekens - en apostrofs bevatten'",
    "goToPartnerSite": "Ga naar partnersite",
    "noPartnersFound": "Geen partners gevonden",
    "noLinkedPartners": "Geen gekoppelde partners",
    "noPartnersInCategory": "Geen partners in categorie",
    "partnerAccountPendingVerification": "Accountverificatie in afwachting",
    "shopWithPartner": "Winkel met partner",
    "shopWithPartnerName": "Winkelen met %{partner_name}",
    "linkToPartnerName": "Link naar %{partner_name}",
    "earnPartnerMembershipIdentifier": "Lidmaatschap-ID",
    "earnPartnerAccountPendingAddLink": "Uw lidmaatschap wordt gekoppeld en het kan enkele dagen duren voordat dit voltooid is.",
    "earnPartnerAccountPendingRemoveLink": "Uw lidmaatschap wordt ontkoppeld en het kan enkele dagen duren voordat dit voltooid is.",
    "linkStatusUpdating": "Linkstatus updaten",
    "activityTracking": {
        "firstActivityModal": {
            "description1": "Gefeliciteerd met het toevoegen van u eerste activiteiten! \n \n Als u wilt, kan u meer activiteiten voor vandaag en andere dagen toevoegen. Als u klaar bent met de activiteiten van vandaag, tap u",
            "description2": "op het volgende scherm als u niets meer te volgen hebt."
        },
        "listTitle": "Activiteiten bijgehouden",
        "dots": {
            "tracked": "Activiteiten bijgehouden op deze dag",
            "added": "Activiteiten zijn toegevoegd en wachten op indiening"
        },
        "trackedActivitiesFor": "Bijgehouden activiteiten voor %{date}",
        "activityTracking": "Activiteit volgen",
        "addedPending": "Toegevoegd (in afwachting van indiening)",
        "search": {
            "description1": "Tap",
            "description2": "om beschikbare activiteiten te bekijken of naar een specifieke activiteit te zoeken"
        },
        "addActivity": "Activiteit toevoegen",
        "addAnotherActivity": "Voeg nog een activiteit toe"
    },
    "rewardsBalance": "Saldo %{currencyName}: %{points}",
    "membershipIdentifierRequiredError": "Uw lidmaatschaps-ID is vereist om te koppelen",
    "incorrectValueInRange": "Voer een waarde in tussen %{min} en %{max}",
    "joinTeam": {
        "title": "Word lid van het team",
        "createInsteadText": "Doe mee of maak een team om deel te nemen aan deze uitdaging"
    },
    "teamRank": "Team rang",
    "teamScore": "Teamscore",
    "appsDevices": {
        "infoText": "U wordt gevraagd om onze technologiepartner Sprout Wellness Solutions, Inc. toestemming te geven voor toegang tot uw welzijnsgegevens wanneer u een app of apparaat toevoegt.",
        "connectModal": {
            "title": "Autorisatie",
            "paragraph1Part1": "U wordt gevraagd om onze technologiepartner te autoriseren",
            "paragraph1Part2": "Sprout Wellness Solutions, Inc.",
            "paragraph1Part3": "om toegang te krijgen tot uw welzijnsgegevens.",
            "paragraph2Desc1": "Uw machtiging staat toe dat",
            "paragraph2Desc2": "Sprout",
            "paragraph2Desc3": "om uw gegevens veilig te syncroniseren",
            "paragraph2Desc4": "met",
            "paragraph2Desc5": ", en helpt u om meer %{pointsName} te verdienen!"
        },
        "statusAlert": {
            "connectMessage": "Sluit een app of apparaat voor het volgen van activiteiten aan en maak het synchroniseren en volgen van activiteiten een fluitje van een cent",
            "connectAction": "Verbind een app of apparaat",
            "errorMessage": "Sommige van uw verbonden apps of apparaten kunnen niet synchroniseren",
            "warningMessage": "Sommige van uw verbonden apps of apparaten hebben mogelijk een verbindingsprobleem",
            "errorAction": "Herstel deze fout",
            "warningAction": "Corrigeer deze waarschuwing",
            "syncingError": "Synchronisatiefout",
            "syncingIssue": "Synchronisatieprobleem"
        },
        "deviceDetails": {
            "warningMessage": "Deze app of dit apparaat heeft problemen met synchroniseren",
            "errorMessage": "Deze app of dit apparaat kan niet synchroniseren",
            "warningAction": "Negeer waarschuwing",
            "noActivities": "Er zijn de afgelopen 7 dagen geen %{deviceName} activiteiten gesynchroniseerd met %{programName}. \n \n  Het kan tot een uur duren voordat activiteiten hier worden weergegeven nadat ze zijn bijgehouden met %{deviceName}.\n \n  Als u een andere app of een ander apparaat hebt aangesloten en er zijn meer stappen bijgehouden door de andere app of het andere apparaat, zie u de activiteit daar. Probeer anders de verbinding met %{deviceName} te verbreken en opnieuw te verbinden. Als u wordt gevraagd om te verifiëren of machtigingen te verlenen, zorg er dan voor dat u activiteitsgegevens inschakelt en hetzelfde account gebruikt om te verifiëren als het account dat is gebruikt om de activiteiten bij te houden. Bekijk de stappen voor troubleshooting voor meer informatie."
        },
        "troubleshooting": "Troubleshooting",
        "deviceItem": {
            "error": "Verbindingsfout",
            "warning": "Waarschuwing voor verbinding",
            "unableToSync": "Kan niet synchroniseren"
        },
        "platformDevice": {
            "defaultApp": "De standaard gezondheidsapp van uw apparaat is",
            "continueMore": "Ga door naar meer apps en apparaten"
        }
    },
    "friendsAndFamily": {
        "learnMore": "Meer informatie over vrienden en familie",
        "learnModal": {
            "title": "Over vrienden & familie",
            "description": "Nadat u iemand aan u vrienden en familie hebt toegevoegd, kan u ervoor kiezen om u posts op %{programName} alleen met ze te delen.\n \n U kan posts die u ziet op %{programName} ook filteren op alleen de mensen op u vrienden- en familielijst als ze naar iedereen of naar u hebben gepost.",
            "description_line1": "Nadat u iemand aan u vrienden en familie hebt toegevoegd, kan u ervoor kiezen om uw posts op %{programName} alleen met ze te delen.",
            "description_line2": "U kan posts die u ziet op %{programName} ook filteren op alleen de mensen op u vrienden- en familielijst als ze naar iedereen of naar u hebben gepost.",
            "whatIconsMean": "Wat de iconen betekenen",
            "canAdd": "Toevoegen",
            "added": "Toegevoegd"
        },
        "searchDescription1": "Zoek naar mensen om toe te voegen aan u vrienden en familie.",
        "searchDescription2": "Zie u niet wie u zoekt? Nodig ze per e-mail uit om lid te worden.",
        "friends&Family": "Vrienden en familie",
        "managingTour": {
            "title": "Vrienden en familie beheren",
            "body": "Als u iemand uit uw vrienden en familie wilt verwijderen, Tapt u op het pictogram"
        },
        "removeOption": "Verwijderen van vrienden en familie",
        "inviteDescription1": "Zoek naar u vrienden en familie.",
        "inviteDescription2": "Zie u niet wie u zoekt?"
    },
    "deletePlatformInvitationToast": {
        "success": {
            "message": "De posts die u alleen met vrienden en familie deelt, zijn niet langer zichtbaar voor %{userFirstName}."
        }
    },
    "skipAll": "Sla alles over",
    "smallMin": "min",
    "eap": {
        "skipModal": {
            "title": "Weet u het zeker?",
            "description": "U kan altijd contact opnemen met het Programma voor werknemers- en gezinsbijstand (EFAP) vanuit uw profiel wanneer u het nodig heeft."
        },
        "contact": {
            "whatIsBestNumber": "Op welk nummer kunnen we u het beste bereiken?",
            "whatIsBestTime": "Wat is het beste moment om contact met u op te nemen?",
            "morning": "Ochtend",
            "afternoon": "Middag",
            "evening": "Avond",
            "additionalDetails": "Aanvullende informatie over de tijd\/datum waarop u gecontacteerd wilt worden",
            "message": "Neem binnen %{weekDay} contact met mij op via %{phoneNumber}. Aanvullende informatie: %{additional}",
            "description": "Let op: We raden u ten zeerste aan om een tijd buiten uw werkuren te kiezen en te kiezen voor een plek waar u een privégesprek kan voeren. Vermeld uw tijdzone."
        },
        "phoneNumber": {
            "empty": "Dit veld kan niet leeg zijn",
            "missingDigits": "Telefoonnummer moet minimaal 4 cijfers bevatten"
        },
        "myEAP": "Mijn Programma voor werknemers- en gezinsbijstand"
    },
    "healthSurveySkipAllTitle": "Welzijnsenquête overslaan",
    "healthSurveySkipAllAlert": "Weet u zeker dat u alle overige vragen van de welzijnsenquête wilt overslaan?",
    "eapSavingWithoutDataToast": {
        "danger": {
            "title": "Programma voor werknemers- en gezinsbijstand",
            "message": "Geef uw telefoonnummer en de beste contacttijd op"
        }
    },
    "allMyChallenges": "Mijn uitdagingen",
    "invitedChallenges": "Uitnodigingen",
    "companyChallenges": "Bedrijfsuitdagingen",
    "completedChallengesEmpty": "Het lijkt erop dat u nog geen uitdagingen hebt voltooid.",
    "myChallengesEmpty": "Het lijkt erop dat u nog niet aan een uitdaging hebt deelgenomen.",
    "allChallengesEmpty": "Er zijn geen uitdagingen.",
    "startsToday": "Begint vandaag",
    "startedDaysAgo": "%{dayCount} dagen geleden begonnen",
    "startsInDays": "Begint over %{dayCount} dagen",
    "privacyOn": "Uit",
    "privacyOff": "Op",
    "dashboard": {
        "viewLeaderboard": "Bekijk leaderboard",
        "timePeriodProgress": "Uw vooruitgang deze %{period}",
        "howToEarn": "Hoe punten te verdienen"
    },
    "privacyChangeConfirmationMessage": "Privacy wijzigen?",
    "privacySettingsTitle": "Privacy",
    "privacySettingsDescription": "U kan de zichtbaarheid van uw foto, naam en profiel voor andere gebruikers contoleren.",
    "mainLeaderBoardSettingsTitle": "? Algemeen leaderboard",
    "challengeLeaderBoardSettingsTitle": "Uitdagingsleaderboard",
    "managePrivacySettingUrlTitle": "Beheer privacy-instellingen",
    "onboardingFamilyPrivacySettingsMessageOn": "U bent zichtbaar in de zoekresultaten van vrienden en familie. U kan ervoor kiezen om uzelf te verbergen voor zoekresultaten.",
    "onboardingFamilyPrivacySettingsMessageOff": "Uw privacy-instellingen verbergen u momenteel in de zoekresultaten van vrienden en familie.",
    "challengeInvitationPrivacySettingsMessageOn": "U bent zichtbaar in de zoekresultaten van challenge-uitnodigingen. U kan ervoor kiezen om uzelf te verbergen voor zoekresultaten.",
    "challengeInvitationPrivacySettingsMessageOff": "Uw privacy-instellingen verbergen u momenteel voor de zoekresultaten van uitnodigingen voor uitdagingen.",
    "challengeParticipationPrivacySettingsMessageOn": "U staat vermeld als deelnemer aan deze uitdaging. U kan ervoor kiezen om u als deelnemer te verbergen voor uw uitdagingen.",
    "challengeParticipationPrivacySettingsMessageOff": "Uw privacy-instellingen verbergen u momenteel voor de deelnemerslijst.",
    "communityInvitationPrivacySettingsMessageOn": "U bent zichtbaar in de zoekresultaten van community-uitnodigingen. U kan ervoor kiezen om uzelf te verbergen voor zoekresultaten.",
    "communityInvitationPrivacySettingsMessageOff": "Uw privacy-instellingen verbergen u momenteel voor zoekresultaten van community-uitnodigingen.",
    "communityParticipationPrivacySettingsMessageOn": "U staat vermeld als lid van deze community. u kan ervoor kiezen om uzelf als lid te verbergen voor u community's.",
    "communityParticipationPrivacySettingsMessageOff": "Uw privacy-instellingen verbergen u momenteel voor de ledenlijst.",
    "eventInvitationPrivacySettingsMessageOn": "U bent zichtbaar in zoekresultaten voor uitnodigingen voor evenementen. U kan ervoor kiezen om uzelf te verbergen voor zoekresultaten.",
    "eventInvitationPrivacySettingsMessageOff": "Uw privacy-instellingen verbergen u momenteel voor zoekresultaten voor uitnodigingen voor evenementen.",
    "eventParticipationPrivacySettingsMessageOn": "U staat vermeld als deelnemer van dit evenement. u kan ervoor kiezen om uzelf als deelnemer te verbergen voor u evenementen.",
    "eventParticipationPrivacySettingsMessageOff": "Uw privacy-instellingen verbergen u momenteel voor de deelnemerslijst.",
    "mainLeaderboardPrivacySettingsMessageOn": "U wordt weergegeven op de algemene leaderboards. u kan ervoor kiezen om uzelf te verbergen, waardoor u rang, foto en naam worden verwijderd wanneer anderen de algemene ranglijsten bekijken.",
    "mainLeaderboardPrivacySettingsMessageOff": "Uw privacy-instellingen verbergen u momenteel wanneer anderen de algemene ranglijsten bekijken.",
    "challengeLeaderboardPrivacySettingsMessageOn": "U wordt weergegeven op challenge leaderboards. u kan ervoor kiezen om uzelf te verbergen, waardoor u rang, foto en naam worden verwijderd wanneer anderen de ranglijsten van uitdagingen bekijken.",
    "challengeLeaderboardPrivacySettingsMessageOff": "Uw privacy-instellingen verbergen u momenteel wanneer anderen de ranglijsten van uitdagingen bekijken.",
    "thumbsUpConfirmationTitle": "Thumbs up",
    "thumbsUpConfirmationDescriptionline1": "Gefeliciteerd, u staat op het punt om u eerste Thumbs up te geven en anderen aan te moedigen!",
    "thumbsUpConfirmationDescriptionline2": "U wordt opgenomen in de lijst met mensen die een Thumbs up hebben gegeven voor dit bericht en anderen kunnen u foto, naam en u profiel zien.",
    "thumbsUpConfirmationButtonOk": "Thumbs up",
    "commentToActionInfoTitle": "Wat zien anderen?",
    "commentToActionMessage": "Wanneer u een reactie plaatst, kunnen anderen uw foto, naam en uw profiel zien.",
    "postToActionTitle": "Wie ziet dit post?",
    "postToActionMessageLine1": "Wanneer u een post maakt, kan u bepalen wie het kan zien en zelfs alleen voor uzelf posten.",
    "postToActionMessageLine2": "De posts die u met anderen deelt, tonen uw foto, naam en anderen kunnen uw profiel bekijken",
    "privateUsersDescriptionChallenge": "Deze deelnemer(s) hebben zich verborgen voor de lijst",
    "privateUsersFirstNamePlaceHolderChallenge": "%{n} privé",
    "privateUsersLastNamePlaceHolderChallenge": "deelnemer(s)",
    "privateUsersDescriptionEvent": "Deze deelnemer(s) hebben zich verborgen voor de lijst",
    "privateUsersFirstNamePlaceHolderEvent": "%{n} privé",
    "privateUsersLastNamePlaceHolderEvent": "deelnemer(s)",
    "privateUsersDescriptionCommunity": "Deze leden hebben zich verborgen voor de lijst",
    "privateUsersFirstNamePlaceHolderCommunity": "%{n} privé",
    "privateUsersLastNamePlaceHolderCommunity": "lid\/leden",
    "noPrivacySettings": "Geen privacy-instellingen",
    "linkToPartnerNameWebsite": "Link via %{partner_name} website",
    "linkToPartnerWebsiteUrl": "Partnerwebsite-URL",
    "start_end_time": "Begin- en eindtijd:",
    "joinCreateTeamPrivacyDisclaimer": "Uw foto, naam en profiel zijn altijd zichtbaar voor iedereen wanneer u uw team in een uitdaging bekijkt, zelfs als u uw privacy-instellingen hebt veranderd naar privé.",
    "carouselInstructions": {
        "swipe": "Veeg over de kaarten om al u doelen en uitdagingen te zien.",
        "click": "Klik op de kaarten om al u doelen en uitdagingen te zien."
    },
    "achieved": "Bereikt",
    "hours": "uur",
    "createCommunityFlow": {
        "navigatorTitle": "Maak een community",
        "stepType": {
            "title": "Zichtbaarheid van de community",
            "subTitle": "Wie kan de community zien en er lid van worden?",
            "privateName": "Privaat",
            "publicName": "Openbaar",
            "privateDescription": "Alleen mensen die u uitnodigt, kunnen de community zien of er lid van worden",
            "publicDescription": "Iedereen kan deze community zien en er lid van worden"
        },
        "stepName": {
            "title": "Geef uw community een naam",
            "subTitle": "Geef uw community een naam die mensen laat weten waar het allemaal om draait.",
            "namePlaceholder": "Community naam",
            "noFieldsTitle": "Naam",
            "noFieldsMessage": "Er wordt geen naam gegeven"
        },
        "stepDescription": {
            "title": "Over uw community",
            "subTitle": "Vertel anderen waar uw community over gaat.",
            "descriptionPlaceholder": "Beschrijving (optioneel)",
            "noFieldsTitle": "Beschrijving",
            "noFieldsMessage": "Er wordt geen beschrijving gegeven"
        },
        "stepImage": {
            "uploadPhotoButtonTitle": "Voeg een foto toe"
        },
        "stepJoin": {
            "title": "We hebben vergelijkbare community's gevonden",
            "subTitle": "Wil u liever lid worden van een van deze community's?"
        },
        "createNew": "Maak een nieuwe community"
    },
    "challengeCard": {
        "allActivities": "Alle activiteiten in de",
        "category": "categorie"
    },
    "myLinkedPartners": "Mijn gekoppelde partners",
    "leaderboardPosition": "Algehele leaderboard positie",
    "remainingInChallenge": "overgebleven in uitdaging",
    "todays_progress": "De vorderingen van vandaag",
    "this_weeks_progress": "De vorderingen van deze week",
    "this_months_progress": "De vorderingen van deze maand",
    "achievement": "prestatie",
    "challengeCardHeader": {
        "challenge": "Uitdaging",
        "recommended_personal_goals": "Aanbevolen persoonlijk doel",
        "personal_goal": "Persoonlijk doel",
        "competition": "Competitie",
        "recommended_goals": "Aanbevolen doel",
        "team_competition": "Team competitie",
        "team": "Team"
    },
    "MyMedibank": "Mijn Medibank",
    "Google": "Google",
    "Facebook": "Facebook",
    "errorEntityTimeMessage": "De eindtijd kan niet vroeger zijn dan de begintijd",
    "company": "Bedrijf",
    "lessThan1DayRemain": "minder dan 1 dag",
    "lessThan1HourRemain": "minder dan 1 uur",
    "remainingToday": "vandaag overgebleven",
    "periodEndsDateAndTime": "Periode eindigt %{date}, %{time}",
    "moreToGo": "Nog %{n} %{unit} om vanaf te gaan",
    "reachedYourGoal": "U hebt u doel %{period} bereikt!",
    "reachedYourGoalToday": "U hebt vandaag u doel bereikt!",
    "editProfileItemCorrectRange": "Geef een geldige %{itemName}-waarde op tussen minimumwaarde %{min} en maximumwaarde %{max}",
    "invalidUrl": "Ongeldige URL",
    "activityLogChanged": {
        "success": "Wijzigingen in de activiteit zijn opgeslaan",
        "info": "Er is iets mis gegaan, probeer het opnieuw",
        "danger": "Er is iets mis gegaan, probeer het opnieuw"
    },
    "discardAlert": {
        "createChallenge": "Weet u zeker dat u deze %{challengeType} wilt verwijderen?",
        "inviteByEmail": "Weet u zeker dat u de wijzigingen wilt annuleren?",
        "createTeam": "Weet u zeker dat u het maken van dit team wilt annuleren?",
        "cancel": "Annuleren",
        "confirm": "Ja, verwijderen"
    },
    "entityInvalidNameError": "De naam van de %{entity} mag alleen getallen of een string value bevatten en mag niet leeg zijn",
    "accept": "Accepteren",
    "sync_now": "Synchroniseer nu",
    "reconnect_device": "Maak opnieuw verbinding",
    "supported_activities": "Ondersteunde activiteiten",
    "recentlySynced_activity": "Recent gesynchroniseerde activiteit",
    "noSyncedActivity_sevenDays": "Er zijn de afgelopen 7 dagen geen activiteiten gesynchroniseerd",
    "recentActivityLog": {
        "convertingActivityPoints": "Activiteiten synchroniseren...",
        "activityMinuteOrTwo": "Dit kan een minuut of twee duren...",
        "noNewActivities": "Geen nieuwe activiteiten toegevoegd... Het kan een uur duren voordat nieuwe activiteiten zijn gesynchroniseerd."
    },
    "deleteCommunityCheckbox": "Ik begrijp dat dit niet ongedaan kan worden gemaakt",
    "createEvent": {
        "type": {
            "company": "Bedrijfsevenement",
            "user": "Gebruikersevenement",
            "title": "Type evenement"
        },
        "privacy": "Privacy (aanwezigen tonen of niet)",
        "cost": "Kosten",
        "associated": {
            "location": "Bijbehorende locatie",
            "department": "Geassocieerde afdeling \/ divisie"
        },
        "maxParticipants": "Max. Deelnemers (optioneel)",
        "errorMessage": {
            "limit": "Kan niet groter zijn dan %{maxValue}",
            "negative": "Mag geen negatieve waarde zijn",
            "selectedLocations": "Selecteer een of meer locaties"
        },
        "selectLocations": "Geselecteerde locaties",
        "createNew": "Maak een nieuw evenement"
    },
    "selected": "Geselecteerd",
    "deleteEventButton": "Verwijder dit evenement",
    "notification": {
        "priorityNotification": {
            "title": "U hebt belangrijke ongelezen updates",
            "subtitle": "Tap om ze nu te lezen",
            "subtitleWeb": "Klik om ze nu te lezen"
        },
        "sectionTitle": {
            "priorityUnread": "Ongelezen belangrijke updates",
            "all": "Alle meldingen"
        },
        "modalTitle": "U hebt %{count} belangrijke updates",
        "priorityModalTitle": {
            "defaultTitle": "Bekijk alle updates"
        }
    },
    "createEntity": {
        "cancel": {
            "title": "%{entity} %{actionType} annuleren",
            "message": "Weet u zeker dat u %{entity} %{actionType} wilt annuleren?"
        },
        "action": {
            "creating": "creëren",
            "editing": "bewerken"
        },
        "type": {
            "team": "team",
            "community": "community",
            "event": "evenement",
            "challenge": "uitdaging",
            "goal": "doel"
        }
    },
    "publicVisibilitySwitch": {
        "modalTitle": {
            "public": "Openbaar maken?",
            "private": "Privé maken?"
        },
        "modalSubtitle": {
            "public": "Door dit %{entityType} openbaar te maken, kan iedereen het ontdekken en meedoen. Weet u zeker dat u deze %{entityType} openbaar wilt maken?",
            "private": "Door dit %{entityType} privé te maken, wordt het afgesloten voor niemand om te ontdekken en er lid van te worden. Weet u zeker dat u deze %{entityType} openbaar wilt maken?"
        },
        "footerButton": {
            "makePublic": "Ja, maak het openbaar",
            "makePrivate": "Ja, maak het privé",
            "keepPrivate": "Houd privé",
            "keepPublic": "Houd openbaar"
        },
        "label": {
            "title": "Maak dit een openbare %{entityType}",
            "subtitle": "Iedereen kan het zien en iedereen kan meedoen"
        }
    },
    "imageUploader": {
        "changeImageButton": "Afbeelding wijzigen"
    },
    "copyright": "Copyright © Sprout 2019",
    "samsunghealth_not_available": "Kan geen verbinding maken met Samsung Health. Zorg ervoor dat u in de Health-app, onder Data Permissions, minimaal toestemming hebt voor stappen en dat er ten minste 1 stap wordt bijgehouden.",
    "rewardsHowDoIEarn": "Hoe verdien ik %{currencyName}?",
    "unlockAchievements": "Ontgrendel prestaties",
    "unlockAchievementsDescription": "Houd activiteiten bij, verdien %{pointsName}, ontgrendel niveaus en verdien meer %{currencyName}. Tap op elke prestatie om te zien wat u moet doen.",
    "myDay": "Mijn dag",
    "myGoalsChallengesTasks": "Mijn doelen, uitdagingen en taken",
    "yourGoalsChallenges": "Uw doelen en uitdagingen",
    "mySocialStream": "Community-berichten",
    "viewAllAchievements": "Bekijk alle prestaties",
    "viewAllBonusChallenges": "Bekijk alle bonusuitdagingen",
    "newVersionOfAppAvailable": "Nieuwe versie beschikbaar! Herlaad deze pagina",
    "noBonusChallengesToDisplay": "Er zijn momenteel geen bonusuitdagingen beschikbaar.",
    "bonusChallenges": "Bonusuitdagingen",
    "reloadAppVersion": "Herladen",
    "appname": "Sprout",
    "cancel_tracking_confirmation": "Weet u zeker dat u %{activity_name} volgen wilt verwijderen?",
    "activity_tracker_instruction_header": "Tap op een dag om activiteiten voor die dag bij te houden of om te zien wat er al is bijgehouden.",
    "alertDashboardFunctionalityToBeAdded": "tekst zal hier worden toegevoegd om uit te leggen wat een volgperiode is, vergelijkbaar met hoe het wordt gedaan voor loyaliteitsprogramma's van luchtvaartmaatschappijen waarbij gebruikers in een kalenderjaar \"miles\" moeten blijven verzamelen om de status voor volgend jaar te krijgen.",
    "noNumberEntered": "Voer de hoeveelheid activiteit in",
    "feed": "Stream",
    "home": "Start pagina",
    "challenges": "Uitdagingen",
    "explore": "Ontdekken",
    "rewards": "Beloningen",
    "reward": "beloning",
    "balance": "Mijn %{programName} rewards-saldo",
    "profile": "Profiel",
    "loading": "Bezig met laden...",
    "me": "Mij",
    "back": "Terug",
    "next": "Volgende",
    "skip": "Overslaan",
    "signup": "Aanmelden",
    "signin": "Log in",
    "signin_maintitle": "Sprout",
    "signin_subtitle": "",
    "signinto": "Log in op Live Better",
    "signup_with_medibank": "Meld u aan als Medibank-lid",
    "signup_with_facebook": "Meld u aan met Facebook",
    "signup_with_google": "Meld u aan met Google",
    "signup_with_email": "Meld u aan met e-mail",
    "signin_with_medibank": "Log in met My Medibank",
    "signin_with_facebook": "Log in met Facebook",
    "signin_with_google": "Log in met Google",
    "signin_with_email": "Log in met e-mail",
    "signup_heading": "Account aanmaken",
    "not_a_medibank_member": "Geen Medibank-lid?",
    "keep_me_signed_in": "Ik wil ingelogd blijven",
    "forgotpassword": "Uw wachtwoord vergeten?",
    "emailaddress": "E-mailadres",
    "password": "Wachtwoord",
    "enterEmailAddress": "Vul u e-mailadres in",
    "enterYourPassword": "Voer uw wachtwoord in",
    "password_for_error": "wachtwoord",
    "reset_password": "Wachtwoord resetten",
    "passwordResetSuccess": "Het wachtwoord is gereset",
    "passwordResetEmailSent": "Als we een overeenkomend e-mailadres in ons systeem hebben, zijn de instructies voor het opnieuw instellen van het wachtwoord naar u gemaild.",
    "loginerror": "Er is een fout opgetreden bij het inloggen:",
    "logincancelled": "Inloggen geannuleerd",
    "part_of_corporate_program": "Meldt u zich aan voor een bedrijfsprogramma?",
    "continue_here": "Ga hier verder",
    "program_name": "Programma naam",
    "error_provide_program_name": "Geef een programmanaam op.",
    "program_not_found": "Programma niet gevonden",
    "registration_field_email": "E-mail",
    "employeeId": "Werknemer-ID",
    "registration_field_firstName": "Voornaam",
    "registration_field_lastName": "Achternaam",
    "no_first_name": "Geen voornaam",
    "no_last_name": "Geen achternaam",
    "registration_field_password": "Nieuw wachtwoord",
    "no_disclaimer_available": "Oeps, er is een probleem opgetreden... We kunnen de algemene voorwaarden van uw organisatie niet ophalen. Probeer u later opnieuw te registreren.",
    "registration_account_not_registered": "Het lijkt erop dat u u e-mailadres nog niet hebt geverifieerd. Wil u dat we de e-mail opnieuw versturen?",
    "resend_verification_email": "Email verificatie",
    "resend_verification_email_successful": "We hebben u verificatie-e-mail opnieuw verzonden.",
    "resend_verification_email_unsuccessful": "Oeps, er is een probleem opgetreden... we konden de verificatie-e-mail niet opnieuw verzenden. Probeer het opnieuw.",
    "not_supported": "Dit bericht kan momenteel niet worden weergegeven. Probeer het later opnieuw.",
    "policyAgreeError": "Ga akkoord met de Servicevoorwaarden en het Privacybeleid om door te gaan.",
    "challenge_completion_bonus": "Voltooiingsbonus",
    "me_tabs": {
        "activity": "Activiteit",
        "bookmarks": "Bladwijzers"
    },
    "health_tab": {
        "my_health_score": "Uw welzijnsscore",
        "overall_health_score_description": "Uw welzijnsscore is",
        "health_score_explanation": "Uw welzijnsscore wordt berekend op basis van uw antwoorden over uw gezondheid en hoe actief u bent. \n \n  Uw score wordt elke maand bijgewerkt op basis van u activiteitsniveau. U kan persoonlijke doelen stellen en voltooien om uw welzijnsscore te verbeteren.",
        "health_score_calculation_failed_onboarding": "Er is iets misgegaan en we hebben uw welzijnsscore niet kunnen ophalen. U kan voorlopig doorgaan en zodra het probleem is verholpen, werken we uw score bij."
    },
    "track_activity": "Volg activiteit",
    "track_an_activity": "Volg een activiteit",
    "track": "Volgen",
    "unable_to_track": "Kan niet volgen",
    "enter_before_track": "Voer de hoeveelheid activiteit in die u wilt volgen",
    "what_to_share": "Wat voor soort update zou u willen delen?",
    "remove": "Verwijderen",
    "activity_tracking_description": "Hoeveel %{units} wilt u bijhouden?",
    "excessive_submission": "Wauw! U staat op het punt meer dan 2.000 %{customPoints} bij te houden voor %{activity_name}. Misschien wilt u ervoor zorgen dat dit klopt voordat u het indient.",
    "on": "op",
    "in": "in",
    "from": "van",
    "at": "bij",
    "no_activities": "Er kwamen geen activiteiten overeen met uw zoekopdracht.",
    "activity_tracking_desc": "U moet een nummer toevoegen om door te gaan. Tap op X in de linkerhoek om te annuleren.",
    "activity_tracking_desc2": "Tap ergens op activiteit om te bewerken, Tap op + om snel naar het doel te gaan",
    "vital_stats_title": "Over u",
    "invalid_numeric_response": "Ongeldig",
    "invalid_numeric_response_range": "Dit aantal moet tussen %{minimum} en %{maximum} liggen",
    "search_placeholder": "Zoek in de bibliotheek...",
    "search_activities": "Zoek activiteiten",
    "searching": "Zoeken...",
    "searchEmpty": "Geen overeenkomsten gevonden",
    "vital_stats_description": "Vertel ons een beetje over uzelf",
    "health_survey_questions": "Welzijnsenquête vragen",
    "health_survey_title": "Welzijnsenquête invullen",
    "health_survey_results": "Resultaten welzijnsenquête",
    "health_survey_card_desc": "Doe mee aan de enquête om een snapshot van uw welzijn te krijgen en persoonlijke doelen te stellen.",
    "apps_devices_title": "Koppel apps en apparaten",
    "apps_devices_card_desc": "Synchroniseer uw apps en apparaten om het verdienen van %{customPoints} een fluitje van een cent te maken.",
    "interests_title": "Interesses",
    "interests_card_desc": "Vertel ons over uw interesses. Dit zal ons helpen doelen en community's aan te bevelen die voor u van belang kunnen zijn.",
    "interests_screen_desc": "Waar ben u in geïnteresseerd?",
    "health_obj_title": "Welzijnsdoelstellingen",
    "health_obj_card_desc": "We denken dat het tijd is om wat doelen te stellen. Zodra we uw doelstellingen kennen, kunnen we u betere aanbevelingen doen. Maak u geen zorgen, als u van gedachten verandert, kan u later eenvoudig wijzigingen aanbrengen in uw profiel.",
    "health_obj_screen_desc": "Aan welke gebieden zou u willen werken?",
    "my_heatlh_obj": "Mijn welzijnsdoelen",
    "health_topic_title": "Welzijnsonderwerpen",
    "health_topic_card_desc": "Personaliseer uw ervaring door uw welzijnsonderwerpen te specificeren.",
    "health_topic_screen_desc": "Waar ben u in geïnteresseerd om over te leren?",
    "multi_select_check_error": "Selecteer minimaal 1 optie om door te gaan",
    "my_health_topics": "Mijn welzijnsonderwerpen",
    "build_your_profile": "Bouw u profiel op",
    "personalize_title": "Personaliseren",
    "personalize_desc": "Personaliseer uw ervaring door een paar korte vragen te beantwoorden.",
    "set_goals_title": "Zie aanbevolen doelen",
    "set_goals_desc": "Stel gepersonaliseerde doelen in om aan de slag te gaan op uw weg naar een betere gezondheid.",
    "set_this_goal": "Stel dit doel in",
    "goal_set": "Doel gesteld",
    "required": "Vereist",
    "apps_devices_description": "Maak verbinding met een fitnessplatform om automatisch meer %{customPoints} te verdienen.",
    "connected": "Verbonden",
    "num_connected": "(%{numDevices} verbonden)",
    "available": "Beschikbaar",
    "inProgress": "Bezig...",
    "time_a_m": "A.M.",
    "time_p_m": "P.M.",
    "last_synced": "Laatst gesynchroniseerd",
    "last_synced_lc": "laatst gesynchroniseerd",
    "no_connected_devices": "Geen verbonden apparaten",
    "apps_devices_confirm_disconnect": "Weet u zeker dat u de verbinding wilt verbreken",
    "button_delete": "Verwijderen",
    "button_disconnect": "Uitschakelen",
    "button_cancel": "Annuleren",
    "button_dismiss": "Afwijzen",
    "ok": "OK",
    "waist_helper_text": "Uw tailleomvang moet onder de ribben worden gemeten, meestal ter hoogte van de navel, en terwijl u staat. Gebruik bij twijfel u uansmaat.",
    "apps_devices_manage": "Beheer mijn apps en apparaten",
    "my_apps_devices": "Mijn apps en apparaten",
    "completeRegistration": "Voltooi registratie",
    "havingTrouble": "Heb u problemen?",
    "contactUs": "Neem contact op met support@sproutatwork.com voor hulp",
    "done": "Klaar",
    "brand": "Sprout",
    "cannotTrackTitle": "Kan activiteit niet volgen",
    "cannotTrackPrior": "Activiteiten kunnen alleen worden gevolgd na de startdatum!",
    "cannotTrackFuture": "Wacht even. Activiteiten kunnen alleen tot op de huidige dag worden gevolgd.",
    "cannotTrack": "Activiteiten kunnen niet worden gevolgd voor een startdatum of voor een dag in de toekomst.",
    "disclaimer": "Disclaimer",
    "acceptTerms": "Ik accepteer de algemene voorwaarden",
    "verificationEmailTitle": "Controleer u email",
    "email_not_yet_verified": "Het lijkt erop dat u u e-mailadres nog niet hebt geverifieerd.",
    "email_successfully_verified_title": "Welkom",
    "email_successfully_verified": "U hebt u e-mailadres geverifieerd",
    "pleaseVerifyEmailMessage1": "U moet uw e-mailadres verifiëren om door te gaan.",
    "pleaseVerifyEmailMessage2": "Volg de instructies die zijn verzonden naar:",
    "supportEmail": "support@sproutatwork.com",
    "resendEmail": "Email opnieuw verzenden",
    "restart": "Terug naar Inloggen",
    "firstName": "Voornaam",
    "firstNamePlaceholder": "Uw voornaam",
    "lastName": "Achternaam",
    "lastNamePlaceholder": "Uw achternaam",
    "email": "E-mail",
    "emailPlaceholder": "Uw e-mailadres",
    "employeId": "Werknemer-ID",
    "employeIdPlaceholder": "Werknemers-ID van het bedrijf",
    "passwordPlaceholder": "Nieuw wachtwoord",
    "datePickerTitle": "Selecteer uw geboortedatum",
    "datePickerConfirm": "Bevestigen",
    "datePickerCancel": "Annuleren",
    "termsOfUsePrivacyPreLinks": "Ik ga akkoord met de",
    "sendMePromoCommunications": "Stuur me promotionele communicatie",
    "sendMePromoCommunicationsFromPartners": "Stuur me promotionele communicatie van partners",
    "termsOfService": "Servicevoorwaarden",
    "legal": "Juridisch",
    "privacyPolicy": "Privacybeleid",
    "and": "en",
    "programDomainLabel": "Programmanaam",
    "programDomainPlaceholder": "Programmanaam",
    "findProgramName": "Zoek mijn programmanaam",
    "findProgramNameButton": "Zoek programmanaam",
    "findProgramNameTitle": "Zoek mijn programmanaam",
    "findProgramNameDescription": "Bedrijfs e-mailadres",
    "findProgramNamePlaceholder": "E-mailadres",
    "findProgramSuccessMessage": "De resultaten van het zoeken naar programmanamen zijn naar u gemaild.",
    "findProgramSuccessTitle": "Programmanaam",
    "findProgramErrorTitle": "Programmanaam",
    "findProgramErrorMessage": "Oeps, er is een probleem opgetreden... Er is een fout opgetreden bij het ophalen van uw programmanaam. Probeer het opnieuw.",
    "countryLabel": "Selecteer land",
    "countryName": "Land",
    "regionLabel": "Selecteer regio",
    "regionName": "Regio",
    "cityLabel": "Selecteer stad",
    "cityName": "Stad",
    "locationWorkLabel": "Selecteer een locatie",
    "locationWorkName": "Locatie",
    "locationLabel": "Selecteer een locatie",
    "locationName": "Locatie",
    "departmentLabel": "Selecteer afdeling \/ divisie",
    "departmentName": "Afdeling \/ divisie",
    "no_department": "Geen afdeling \/ divisie",
    "enterPIN": "Voer uw bedrijfspincode in",
    "verifyEmailTitle": "Email verificatie",
    "verifyEmailMsg": "Het lijkt erop dat u uw e-mailadres nog niet hebt geverifieerd",
    "resendEmailTitle": "Email verificatie",
    "resendEmailMsg": "Opnieuw verzonden naar %{userEmail}",
    "select_date": "Selecteer een datum",
    "changePasswordTitle": "Verander wachtwoord",
    "currentPassword": "Huidig wachtwoord",
    "newPassword": "Nieuw wachtwoord",
    "confirmNewPassword": "Bevestig nieuw wachtwoord",
    "passwordChangeError": {
        "currentPasswordMissing": "Voer uw huidige wachtwoord in",
        "newPasswordMissing": "Typ uw nieuwe wachtwoord",
        "confirmPasswordMissing": "Bevestig uw nieuwe wachtwoord",
        "passwordsMatch": "Wachtwoorden komen niet overeen",
        "passwordIncorrect": "Onjuist wachtwoord. Probeer het opnieuw."
    },
    "settings": "Instellingen",
    "signOut": "Afmelden",
    "updateApp": "App bijwerken",
    "updateAppRight": "Huidig: %{version}",
    "appleStoreUrlSprout": "https:\/\/itunes.apple.com\/us\/app\/sprout-at-work\/id904741273",
    "playStoreUrlSprout": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.sproutmobileapp",
    "appleStoreUrlLiveBetter": "https:\/\/itunes.apple.com\/us\/app\/live-better\/id1289314646",
    "playStoreUrlLiveBetter": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.livebetter",
    "appleStoreUrlTelus": "https:\/\/apps.apple.com\/app\/telus-health-wellbeing\/id1627569346",
    "playStoreUrlTelus": "https:\/\/play.google.com\/store\/apps\/details?id=com.telus.health.wellbeing",
    "appleStoreUrlUPnGO": "https:\/\/itunes.apple.com\/us\/app\/upngo-with-participaction\/id1079958142",
    "playStoreUrlUPnGO": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.upngo",
    "getHelp": "Hulp krijgen",
    "feedback": "Feedback",
    "feedback_success_title": "Feedback ingediend",
    "feedback_success_msg": "Bedankt voor het doorgeven van uw feedback, dat stellen wij zeer op prijs!",
    "feedback_failure_title": "Fout",
    "feedback_failure_msg": "Jammer... Er is een fout opgetreden bij het verzenden van uw feedback, probeer het opnieuw.",
    "submit": "Indienen",
    "feedback_char_limit": "U heeft de tekenlimiet overschreden.",
    "feedback_char_limit_toast_title": "Bericht te lang",
    "feedback_char_limit_toast_msg": "Uw bericht overschrijdt de maximale limiet van 2000 tekens.",
    "feedback_char_length_msg_1": "U hebt getypt:",
    "feedback_char_length_msg_2": "\/2000 tekens.",
    "feedback_empty_toast_title": "Bericht leeg",
    "feedback_empty_toast_msg": "Het lijkt erop dat u nog niets hebt getypt. Typ een bericht voordat u het verzendt.",
    "feedback_email_message": "Bericht:",
    "feedback_email_user_id": ", Gebruikersnaam:",
    "feedback_email_device": ", Apparaat:",
    "feedback_email_os_version": ", OS-versie:",
    "feedback_email_app_version": ", App versie:",
    "savingUserToast": {
        "success": {
            "title": "Wijzigingen opslaan",
            "message": "Profielwijzigingen opgeslaan"
        },
        "danger": {
            "title": "Er is een fout opgetreden",
            "message": "Oeps... Er is een fout opgetreden bij het opslaan van uw wijzigingen. Probeer het opnieuw."
        }
    },
    "edit_profile_user_error_msg": "Controleer de fouten voordat u probeert uw wijzigingen op te slaan",
    "edit_profile_location_error": "U moet uw locatie opgeven",
    "edit_profile_department_error": "U moet uw afdeling \/ divisie specificeren",
    "edit_profile_unspecified_value": "U moet een waarde opgeven",
    "edit_profile_value_too_low": "De waarde moet groter zijn dan",
    "edit_profile_value_too_high": "De waarde moet kleiner zijn dan",
    "choose_gender": "Selecteer geslacht",
    "activity_tracked_successfuly": "Uw activiteit wordt bijgehouden",
    "multi_activity_tracked_successfully": "Uw activiteiten worden bijgehouden",
    "no_activities_tracked": "Geen activiteiten bijgehouden",
    "track_activity_to_submit": "Kies een datum op de kalender om een activiteit bij te houden",
    "last_day": "Laatst",
    "days_remaining": "overige dagen",
    "day_remaining": "overige dag",
    "days_remaining_this_week": "overige dagen deze week",
    "day_remaining_this_week": "overige dag deze week",
    "days_remaining_this_month": "overige dagen deze maand",
    "day_remaining_this_month": "overige dag deze maand",
    "earned_today": "Vandaag verdiend",
    "earned_this_week": "Deze week verdiend",
    "earned_this_month": "Deze maand verdiend",
    "earned_in_total": "In totaal verdiend",
    "goal_completed": "Doel voltooid,",
    "see_results": "zie resultaten",
    "pts": "%{customPoints}",
    "of": "van",
    "daily_goal": "Dagelijks doel",
    "weekly_goal": "Wekelijks doel",
    "monthly_goal": "Maandelijks doel",
    "total_goal": "Totaal doel",
    "weeks": "weken",
    "today": "Vandaag",
    "this_week": "Deze week",
    "this_month": "Deze maand",
    "overall": "Algemeen",
    "level": "Niveau",
    "days_remaining_in_period": "%{remainingDays} overige dagen",
    "days_left_in_period": "%{remainingDays} overige dagen om te volgen",
    "pointsToLevel": "Vooruitgang na %{levelName}",
    "levelCompleted": "%{levelName} voltooid",
    "keepTrackingUntil": "Blijf volgen tot",
    "activityLevelTitle": "Mijn activiteitsniveau",
    "activityLevelDescription": "Hoeveel tijd besteedt u aan minstens matig actief zijn - dat is wanneer u hard genoeg werkt om uw hartslag te verhogen en te zweten - in een normale week?",
    "activityLevelUnder60": "Minder dan 60 minuten",
    "activityLevelUnder150": "60 tot 150 minuten",
    "activityLevelOver150": "Meer dan 150 minuten",
    "gender_male": "Mannelijk",
    "gender_female": "Vrouwelijk",
    "gender_rather_not_say": "Liever niet zeggen",
    "date_of_birth": "Geboortedatum",
    "height": "Lengte",
    "Height": "Lengte",
    "weight": "Gewicht",
    "waistCircumference": "Tailleomtrek",
    "bloodPressureHg": "Systolische bloeddruk",
    "bloodPressureMm": "Diastolische bloeddruk",
    "bloodCholesterol": "Totaal bloedcholesterol",
    "ldl": "Lage Densiteit Lipoproteïne (LDL)",
    "hdl": "Hoge Densiteit Lipoproteïne (HDL)",
    "restingHeartRate": "Rustende hartslag",
    "percentageBodyFat": "Percentage lichaamsvet",
    "hipCircumference": "Heupomtrek",
    "bloodGlucose": "Bloedglucose",
    "triglycerides": "Triglyceriden",
    "error_401_signed_out_message": "Uw sessie is verlopen. Log alsublieft nogmaals in.",
    "first_name": "Voornaam",
    "last_name": "Achternaam",
    "preferred_name": "Voorkeursnaam",
    "notifications": "Meldingen",
    "notificationsMarkAllReadButton": "Markeer alle meldingen als gelezen",
    "notificationsSettingsButton": "Instellingen",
    "notificationsSettingsTitle": "Meldingen & e-mails",
    "notificationEmptyMessage": "U bent op de hoogte van u meldingen",
    "priorityModalTitle": "Mijn prioriteitsmeldingen",
    "remindMeLater": "Herinner me er later aan",
    "priorityAdminTitle": "Melding van uw beheerder",
    "markAsRead": "Markeer als gelezen",
    "expand": "Tap om uit te vouwen",
    "collapse": "Tap om samen te vouwen",
    "takePhoto": "Neem een nieuwe foto",
    "choosePhoto": "Selecteer een foto",
    "deletePhoto": "Verwijder foto",
    "profileImageChangeErrorTitle": "Er is een fout opgetreden",
    "profileImageChangeErrorMessage": "Oeps... Er is iets misgegaan met het bewerken van u foto. Probeer het opnieuw.",
    "editProfile": "Bewerk profiel",
    "postButton": "Posten",
    "shareYourDayName": "Wat ben u van plan?",
    "greeting": "Hallo, %{firstNameDisplay}!",
    "shareAnUpdate": "Wat ben u van plan?",
    "shareYourDaySubtitle": "Wat ben u van plan?",
    "shareAPost": "Deel een post",
    "postVisibleTo": "Zichtbaar voor",
    "link": "Link",
    "photo": "Foto",
    "insertLink": "Voeg een link toe aan u post",
    "save": "Opslaan",
    "sampleLink": "http:\/\/sample.com",
    "shareErrorText": "U moet inhoud aan uw bericht toevoegen voordat u het verzendt.",
    "generalErrorTitle": "Bericht leeg",
    "generalSuccessTitle": "Succes",
    "simplePlaceholder": "Wat ben u van plan?",
    "likesCountLabel": "Thumbs up",
    "likesReceivedLabel": "Thumbs up ontvangen",
    "commentsCountLabel": "Reactieen",
    "commentsCountLabelSingular": "Reactie",
    "likeButton": "Thumbs up",
    "commentButton": "Reactie",
    "seePreviousComments": "Zie eerdere reacties",
    "addCommentPlaceholder": "Voeg een reactie toe",
    "postCommentButton": "Posten",
    "seeMoreLongComment": "Bekijk meer",
    "activityPoints": "%{customPoints}",
    "activityLog": "Activiteitenlogboek",
    "discardPost": "Verwijderen",
    "discardPostMessage": "Weet u zeker dat u uw post wilt verwijderen?",
    "stream_filter_title": "Stream",
    "stream_filter_screen_desc": "Selecteer de posts die u in de updates wilt zien",
    "stream_filter_selection": "Tonen:",
    "moderate": "Markeer als ongepast",
    "moderateDescription": "Als u dit item als ongepast markeert, wordt het verwijderd en wordt een beheerder op de hoogte gesteld.",
    "editPost": "Post bewerken",
    "deletePost": "Verwijder post",
    "deleteComment": "Reactie verwijderen",
    "editComment": "Reactie bewerken",
    "visibleOnlyToMe": "Alleen zichtbaar voor mij",
    "joinEvent": "RSVP voor evenement",
    "joinEventDetail": "Doe mee aan evenement",
    "joinedEvent": "Ik ga",
    "joiningEventToast": {
        "success": {
            "title": "%{eventName}",
            "messageName": "U hebt lid geworden van het evenement",
            "message": "U hebt met succes lid geworden van dit evenement"
        }
    },
    "joinChallenge": "Doe mee aan de uitdaging",
    "viewChallenge": "Bekijk uitdaging",
    "joinedChallenge": "Gezamenlijke uitdaging",
    "joinCommunity": "Lid worden van de community",
    "joinedCommunity": "Lid geworden van de community",
    "joinProgress": "Lid worden",
    "joinSuccess": "Lid geworden",
    "invitePeopleToCommunity": "Nodig mensen uit voor de community",
    "numberOfMembers": "%{num} leden",
    "joinToView": "Word lid van deze community om andere leden te bekijken en te posten",
    "numberOfAttendees": "%{num} deelnemer(s)",
    "numberOfParticipants": "%{num} deelnemers",
    "numberOfMembersWithUser": "U en %{num} andere leden",
    "numberOfAttendeesWithUser": "U en %{num} andere deelnemer(s)",
    "numberOfParticipantsWithUser": "U en %{num} andere deelnemer(s)",
    "communityMembers": "%{numberOfMembers} lid\/leden",
    "communityEvents": "%{numberOfEvents} aankomend evenement(en)",
    "myEvents": "Mijn evenementen",
    "seeAll": "Alles zien",
    "noUpcomingEvents": "Geen aankomende evenementen. Laten we aan een evenement meedoen!",
    "myCommunities": "Mijn community's",
    "invitedCommunities": "Uitgenodigd",
    "invitationSendingMessage": "Uitnodigingen verzenden...",
    "invitationReceivedMessage": "heeft u uitgenodigd om hieraan deel te nemen",
    "invitationMessage": "We zouden u graag in onze community hebben!",
    "recommendedCommunities": "aanbevolen voor u",
    "leaveCommunity": "Verlaat deze community",
    "leaveTeam": "Weet u zeker dat u het team wilt verlaten",
    "leaveTeamLastMember": "bij deze uitdaging? Als u als laatste lid van het team de uitdaging verlaat, wordt het team verwijderd.",
    "leaveTeamChallenge": "bij deze uitdaging?",
    "Oops": "Oeps! Er is iets misgegaan",
    "editCommunity": "Community bewerken",
    "deleteCommunity": "Verwijder deze community",
    "leaveCommunityDescription": "Weet u zeker dat u deze community wilt verlaten?",
    "inviteToCommunity": "Uitnodigen voor community",
    "inviteByMembers": "Nodig uit op naam",
    "inviteByEmail": "Nodig uit via email",
    "select_person": "Selecteer ten minste één persoon om uit te nodigen",
    "no_users_found": "Hmm... we kunnen niemand met die naam vinden.",
    "promptJoinCommunities": "Het lijkt erop dat u nog geen lid bent van een community. Word lid van community's om met anderen in contact te komen en uw reis te delen.",
    "exploreCommunities": "Verken community's",
    "sendInviteByMembers": "Nodig %{num} mensen uit",
    "sendInviteByEmail": "E-mailuitnodiging verzenden",
    "createNewCommunity": "Maak een nieuwe community",
    "createCommunity": "Maak community",
    "uploadCover": "Voeg een foto toe",
    "cover": "Omslag",
    "nameOfCommunity": "Community naam",
    "whatCommunityAbout": "Waar gaat deze community over?",
    "companyMembersOnly": "Alleen leden van het bedrijf",
    "viewAllButton": "Bekijk alles",
    "communities": "Community's",
    "contentLibrary": "Bibliotheek",
    "events": "Evenementen",
    "past_events": "Gebeurtenissen uit het verleden",
    "invitationCommunity": "community",
    "searchPeople": "Zoek mensen",
    "enterEmail": "Voer email in",
    "personalMessageToNewInvitees": "Persoonlijk bericht aan nieuwe genodigden",
    "dangerToastTitle": "Fout",
    "dangerToastMessage": "Hmm... Er is iets misgegaan. Probeer het opnieuw.",
    "successToastTitle": "Succes",
    "successToastMessage": "Actie voltooid",
    "joiningToast": {
        "success": {
            "message": "U bent lid geworden"
        }
    },
    "deletingCommentToast": {
        "success": {
            "message": "Reactie verwijderd"
        }
    },
    "moderatingCommentToast": {
        "success": {
            "message": "Reactie gemarkeerd als ongepast"
        }
    },
    "editingCommentToast": {
        "success": {
            "message": "Reactie bijgewerkt"
        }
    },
    "gettingLikesToast": {
        "success": {
            "message": "Reactie bijgewerkt"
        }
    },
    "updatingAvatarToast": {
        "success": {
            "message": "Profielfoto bijgewerkt"
        }
    },
    "deletingAvatarAvatarToast": {
        "success": {
            "message": "Foto foto verwijderd"
        }
    },
    "creatingStreamToast": {
        "success": {
            "title": "Post naar streamen",
            "message": "U post is gemaakt"
        }
    },
    "editingStreamToast": {
        "success": {
            "title": "Post bewerken",
            "message": "U post is bewerkt"
        }
    },
    "deletingPostToast": {
        "success": {
            "title": "Verwijder post",
            "message": "U post is verwijderd"
        }
    },
    "moderatingPostToast": {
        "success": {
            "title": "Markeer als ongepast",
            "message": "Post gemarkeerd als ongepast"
        }
    },
    "markingAllNotificationsToast": {
        "success": {
            "title": "Markeer als gelezen",
            "message": "Alle meldingen gemarkeerd als gelezen"
        },
        "info": {
            "title": "Markeer als gelezen",
            "message": "Alle meldingen zijn al gemarkeerd als gelezen."
        },
        "danger": {
            "title": "Markeer als gelezen"
        }
    },
    "markingNotificationToast": {
        "danger": {
            "title": "Kan de melding niet als gelezen markeren"
        }
    },
    "changePasswordToast": {
        "success": {
            "title": "Wachtwoord bijgewerkt",
            "message": "Meld u aan met uw nieuwe wachtwoord"
        },
        "danger": {
            "title": "Wachtwoord bijwerken",
            "message": "Oeps... Er ging iets mis met het bijwerken van u wachtwoord. Probeer het opnieuw."
        }
    },
    "joining": {
        "success": {
            "message": "U bent lid geworden van %{name}"
        }
    },
    "invitingUsersToast": {
        "success": {
            "title": "Uitnodigingen",
            "message": "Uitnodiging(en) zijn verzonden"
        }
    },
    "creatingCommunityToast": {
        "success": {
            "title": "Maak community aan",
            "message": "U nieuwe community is gemaakt"
        }
    },
    "restartingCustomGoalToast": {
        "success": {
            "message": "U doel is opnieuw begonnen"
        },
        "danger": {
            "message": "Kan doel niet herstarten"
        }
    },
    "quit": "Stoppen",
    "wellbeing_survey_completed": "Welzijnsenquête voltooid",
    "wellbeing_survey_completed_message": "Bedankt voor het voltooien van de enquête. We hopen dat u hiermee enig inzicht heeft gekregen in uw welzijn.",
    "update_wellbeing_score": "Werk mijn enquêteantwoorden bij",
    "get_wellbeing_score": "Krijg uw welzijnsscore",
    "stats": "Statistieken",
    "my_wellbeing_score": "Mijn welzijnsscore",
    "see_details": "Zie de details",
    "how_score_calculated": "Hoe wordt mijn score berekend?",
    "contentTitle": "Bibliotheek",
    "promoted": "Aanbevolen",
    "recommended": "Aanbevolen",
    "recommendedForMe": "Aanbevolen voor mij",
    "recent": "Recent toegevoegd",
    "view": "Bekijken",
    "added": "Toegevoegd",
    "more": "meer",
    "openLibrary": "Breng me naar de bibliotheek",
    "readToEarn": "Lees om te verdienen",
    "readArticle": "Open link",
    "see_more": "Zie meer (%{num})",
    "see_more_activities": "%{num} meer",
    "my_achievements": "Mijn prestaties",
    "achievements": "Prestaties",
    "achievement_earned_date": "Verdiend: %{date}",
    "achievement_start_date": "Begonnen: %{date}",
    "achievement_end_date": "Eindigt: %{date}",
    "achievement_earned": "Verdiend",
    "achievement_start": "Begint",
    "achievement_end": "Eindigt",
    "achievement_earned_times": "%{num} keer",
    "achievement_earned_time": "%{num} keer",
    "in_progress": "Bezig",
    "date_earned": "Datum verdiend",
    "earned": "Verdiend",
    "past_dates_earned_heading": "Datums uit het verleden verdiend",
    "all": "Alle",
    "eat": "Eten",
    "move": "Bewegen",
    "feel": "Voelen",
    "profile_completion": "Profiel voltooid: %{percentage}%",
    "complete_my_profile": "Voltooi uw profiel",
    "do_following_tasks": "Voer de volgende %{num} taak uit om uw profiel te voltooien.",
    "improve_my_score": "Verbeter u score",
    "see_which_goals": "Bekijk de doelen die u hebt gesteld op het gebied van eten, bewegen en u beter voelen.",
    "havent_set_goal": "U hebt nog geen doel gesteld.",
    "set_a_goal": "Een doel stellen",
    "set_another_goal": "Stel een ander doel in",
    "set_another_goal_here": "Stel hier een ander doel in.",
    "my_recently_tracked_activities": "Mijn recente activiteiten",
    "a_few_seconds_ago": "een paar seconden geleden",
    "a_day_ago": "een dag geleden",
    "yesterday": "Gisteren",
    "earn": "Verdienen",
    "delete_activity_confirmation": "Weet u zeker dat u deze activiteit wilt verwijderen?",
    "delete_activity_title": "%{measurement} van %{activity_name} verwijderen?",
    "reached_daily_goal": "U hebt vandaag u doel bereikt. Goed gedaan!",
    "multiple_activity_non_daily_instruction": "Tap op een activiteitsrij om te beginnen met volgen en %{customPoints} te verdienen!",
    "multiple_activity_daily_instruction": "Tap op het plusteken om de hoeveelheid activiteit bij te houden die nodig is om uw doel te bereiken. Tap ergens anders op de activiteitsrij om elke hoeveelheid van die activiteit bij te houden.",
    "only_automatic_activities": "De activiteiten die bijdragen aan dit doel kunnen alleen automatisch worden bijgehouden",
    "only_automatic_activity": "De activiteit die bijdraagt aan dit doel kan alleen automatisch worden bijgehouden",
    "earn_pts_and_reach_goal": "Verdien %{pts} punten en bereik uw doel door %{qty} bij te houden",
    "earn_pts_for_every": "Verdien %{pts} punten voor elke",
    "you_track": "u volgt!",
    "you_have_tracked": "u hebt %{qty} gevolgd tot",
    "so_far": "dusver!",
    "start_goal": "Stel dit doel in",
    "about_this_goal": "Over dit doel",
    "start_date": "Begindatum",
    "end_date": "Einddatum",
    "activities": "Activiteiten",
    "goal": "Doel",
    "instructions": "Instructies",
    "daily": "Dagelijks",
    "weekly": "Wekelijks",
    "monthly": "Maandelijks",
    "total": "Totaal",
    "week": "Week",
    "day": "Dag",
    "days": "Dagen",
    "month": "Maand",
    "months": "Maanden",
    "progress": "Vooruitgang",
    "about": "Over",
    "days_remaining_to_track": "U hebt %{num} dagen om gemiste activiteiten bij te houden",
    "number_days": "%{num} dagen",
    "one_day": "1 dag",
    "points_earned_this_week": "Punten verdiend deze week",
    "points_earned_year": "Punten verdiend tot nu toe",
    "completed": "Voltooid",
    "what_you_need_to_do": "Wat u moet doen",
    "see_all_num": "Bekijk alle %{num}",
    "my_week_progress": "Uw wekelijkse vooruitgang",
    "my_day_progress": "Uw dagelijkse vooruitgang",
    "my_month_progress": "Uw maandelijkse vooruitgang",
    "my_total_progress": "Uw totale vooruitgang",
    "my_overall_progress": "Algehele vooruitgang",
    "you_earned": "U hebt",
    "of_this_week": "van %{num} deze week verdiend",
    "of_this_day": "van %{num} vandaag verdiend",
    "of_this_month": "van %{num} deze maand verdiend",
    "of_this_total": "van %{num} in totaal verdiend",
    "of_this_overall": "van %{num} in totaal verdiend",
    "remaining_this_week": "overig deze week",
    "remaining_this_month": "overig deze maand",
    "remaining_this_total": "overig",
    "remaining_this_overall": "totaal overgebleven",
    "view_history": "Bekijk geschiedenis",
    "this_goal_is": "Dit doel is",
    "will_run_for": "Zal rennen voor",
    "button_unset_goal": "Niet ingesteld doel",
    "button_leave_challenge": "Uitdaging verlaten",
    "leaveChallenge": {
        "menu": "%{challengeName} verlaten"
    },
    "deleteChallenge": {
        "menu": "%{challengeName} verwijderen"
    },
    "unsetGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "u hebt dit persoonlijke doel ongedaan gemaakt."
        }
    },
    "leaveChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "U hebt de uitdaging verlaten."
        }
    },
    "activities_tracked": "Activiteiten bijgehouden",
    "recently_tracked_activities": "Recent bijgehouden activiteiten",
    "add": "Toevoegen",
    "change_before_track": "Het lijkt erop dat u geen wijzigingen heeft aangebracht. Bewerk de hoeveelheid activiteit voor deze dag of sluit af zonder wijzigingen aan te brengen.",
    "havent_tracked_today": "Het lijkt erop dat u nog geen activiteit voor deze dag hebt bijgehouden. Begin met het zoeken naar een activiteit.",
    "cancel_tracking_quantity": "Annuleer %{quantity} volgen van %{activity_name}",
    "points": "%{customPoints}",
    "discard_activity_edits_confirmation": "Als u afsluit, worden bewerkingen in uw activiteitengeschiedenis verwijderd. Weet u zeker dat u wilt afsluiten?",
    "discard_activity_edits_confirmation_date": "Als u afsluit, worden bewerkingen in uw activiteitengeschiedenis voor %{date} verwijderd. Weet u zeker dat u wilt afsluiten?",
    "yes_discard_edits": "Ja, sluit af en verwijder bewerkingen",
    "createGoal": {
        "navigatorTitle": "Maak persoonlijk doel",
        "navigatorSubtitle": "Stap %{step} van 4"
    },
    "allCommunities": "Alles",
    "deleteCommunityDescription": "Weet u zeker dat u deze community wilt verwijderen?",
    "remaining": "overig",
    "recommended_goal": "Aanbevolen doel",
    "pinError": "Pincode %{pin} is niet geldig. Probeer het opnieuw.",
    "previousPersonalGoals": "Mijn voltooide persoonlijke doelen",
    "previousGoalsTitle": "Mijn vorige doelen",
    "endedOn": "ëindigde op",
    "achievedOfGoal": "U hebt %{num}% van het doel bereikt",
    "previousGoalsEmptyMessage": "U hebt geen eerdere doelen",
    "emptyListDefaultMessage": "U hebt hier geen items",
    "myCommunitiesEmpty": "Het lijkt erop dat u nog geen lid bent van een community. Word lid van community's om met anderen in contact te komen en uw reis te delen.",
    "discoverMoreCommunities": "Ontdek meer community's",
    "howLong": "Duur",
    "frequency": "Frequentie",
    "discard": "Verwijderen",
    "description": "Beschrijving",
    "optional": "optioneel",
    "instruction": "Instructie",
    "name": "Naam",
    "create": "Aanmaken",
    "categories": "Categorieën",
    "uploadPhoto": "Voeg een foto toe",
    "delete_goal": "Verwijder %{name}",
    "delete_goal_confirmation": "Weet u zeker dat u dit doel wilt verwijderen?",
    "leave_goal_confirmation": "Weet u zeker dat u deze uitdaging wilt verlaten?",
    "creatingCustomGoalToast": {
        "success": {
            "message": "U doel is gemaakt."
        }
    },
    "defaultSelectMessage": "Selecteer een optie",
    "search": "Zoeken",
    "inTotal": "in totaal",
    "State": "Staat\/Provincie",
    "Business unit": "Bedrijfseenheid",
    "Work location": "Werk locatie",
    "whenStart": "Wanneer wil u beginnen?",
    "every": "elk",
    "acceptChallenge": "Accepteer uitdaging",
    "activity_history_challenge": "Activiteitsgeschiedenis voor uitdaging",
    "havent_tracked_challenge": "U hebt geen activiteiten bijgehouden voor deze uitdaging",
    "earned_lowercase": "verdiend",
    "noone_tracked_yet": "Niemand heeft nog iets bijgehouden. Begin met volgen om aan de leiding te gaan in deze wedstrijd!",
    "you": "U",
    "your_team": "Mijn team",
    "congrats_first_place": "Gefeliciteerd u staat op de eerste plaats! Ga zo door.",
    "leader": "Leider",
    "average": "Gemiddeld",
    "show_leader": "Toon leider",
    "show_me": "Toon me",
    "show_my_team": "Toon mijn team",
    "leaderboard": "Leaderboard",
    "my_team": "Mijn team",
    "remaining_to_track": "overig te volgen",
    "avg": "gem",
    "invite": "Uitnodigen",
    "team_members": "Leden van het team",
    "daysLeft": "Overige dagen",
    "regionNameLiveBetter": "Staat\/Provincie",
    "locationNameLiveBetter": "Werk locatie",
    "departmentNameLiveBetter": "Bedrijfseenheid",
    "regionLabelLiveBetter": "Selecteer staat\/provincie",
    "locationLabelLiveBetter": "Kies werklocatie",
    "departmentLabelLiveBetter": "Selecteer bedrijfsonderdeel",
    "companyLocation": "Werk locatie",
    "no_location": "Geen locatie",
    "connect": "Aansluiten",
    "syncing": "synchroniseren",
    "sync": "Synchroniseren",
    "havent_tracked_in_a_while": "Geen recent bijgehouden activiteiten",
    "contact": "Contact",
    "manage": "Beheren",
    "creator": "Maker",
    "allow_notifications": "Meldingen beheren",
    "enable_notifications": "Meldingen aanzetten",
    "appload": "Wacht even terwijl {app_name} wordt bijgewerkt...",
    "sendResetEmail": "Stuur een reset-e-mail",
    "min": "min",
    "max": "Max",
    "error_joining_team": "Kan niet deelnemen aan het team",
    "cannot_add_to_team": "Oeps... Er ging iets mis bij u toevoeging aan dit team. Het kan zijn dat het team het maximale aantal leden heeft bereikt of niet meer bestaat. Als er nog een fout is opgetreden, probeert u het opnieuw.",
    "members_needed": "%{num} leden nodig",
    "member_needed": "%{num} lid nodig",
    "spots_left": "%{num} overige plaatsen",
    "join": "Meedoen",
    "no_teams_create": "Er zijn momenteel geen teams waar u lid van kan worden. Waarom maak u er geen?",
    "number_teams": "%{num} teams",
    "youLowercase": "U",
    "joined_challenge_on_team": "U hebt lid geworden van een uitdaging van team %{team_name}.",
    "join_team": "Lid worden van een team",
    "former_members": "Voormalige leden",
    "letsGo": "Laten we gaan",
    "invite_to_team": "Nodig uit voor team",
    "connectingDeviceToast": {
        "success": {
            "title": "Verbind een app of apparaat",
            "message": "Succes! u app of apparaat is verbonden."
        },
        "danger": {
            "title": "Verbind een app of apparaat",
            "message": "Oeps... Er is een probleem opgetreden bij het verbinden van deze service. Probeer het opnieuw."
        }
    },
    "disconnectingDeviceToast": {
        "success": {
            "title": "Koppel een app of apparaat los",
            "message": "U heeft %{name} met succes losgekoppeld."
        },
        "danger": {
            "title": "Koppel een app of apparaat los",
            "message": "Oeps... We hadden een probleem bij het loskoppelen van %{name}. Probeer het opnieuw."
        }
    },
    "leave_entity_question": "%{name} verlaten?",
    "delete_entity_question": "%{name} verwijderen?",
    "leave_team_challenge_confirmation": "Weet u zeker dat u %{name} in deze uitdaging wilt verlaten?",
    "leave_last_team_member": "Als u als laatste lid van het team deze uitdaging verlaat, wordt het team verwijderd.",
    "oops_msg": "Oeps... Er is een fout opgetreden bij het voltooien van deze actie. Probeer het opnieuw.",
    "has_been_created": "U hebt lid geworden van de uitdaging van team %{name}.",
    "specify_team_name": "Geef een teamnaam op",
    "invite_members": "Nodig leden uit",
    "upload_photo_no_question": "Voeg een foto toe",
    "my_progress": "Mijn vooruitgang",
    "rewardsPointsAdditionalInfo": "Verdien %{reward_currency} voor elk bereikt niveau elke %{period}. Uw %{customPoints} en niveau's beginnen elke %{period} opnieuw, dus u hebt de mogelijkheid om %{reward_currency} te blijven verdienen, zelfs als u de laatste periode het hoogste niveau hebt bereikt.",
    "rewardsPointsInfo": "Uw %{customPoints} en vooruitgang worden elke %{period} gereset.",
    "departments": "Afdelingen \/ Divisies",
    "regions": "Regio's",
    "noItemsSelected": "Geen items geselecteerd",
    "pleaseSelectOne": "Selecteer ten minste één item uit de lijst",
    "tracked": "Bijgehouden",
    "starts": "Begint",
    "duration": "Duur",
    "bonus": "Bonus",
    "invited_by": "Uitgenodigd door",
    "create_team": "Maak een team",
    "discardConfirmation": "Weet u zeker dat u wilt afsluiten?",
    "discardYes": "Ja",
    "discardStay": "Ga terug",
    "create_team_toast_title": "Team aanmaken",
    "edit_team": "Team bewerken",
    "team_edits_submitted": "Uw team is bijgewerkt.",
    "challenge_ended_still_trackable": "Deze %{type} is afgelopen, gelukkig heb u nog %{num} dagen om bij te houden!",
    "tracking_period_ended": "De volgperiode voor dit %{type} is afgelopen.",
    "unlimited": "Onbeperkt",
    "ends_in": "Eindigt binnen",
    "challenge_toast": {
        "success": {
            "join": "Succes!",
            "message": "U hebt u met succes aangemeld voor de uitdaging."
        },
        "danger": {
            "error": "Fout",
            "message": "Er is iets fout gegaan. Probeer over een tijdje opnieuw aan te nemen voor de uitdaging."
        }
    },
    "members_to_invite": "Leden om uit te nodigen",
    "members_to_remove": "Leden om te verwijderen",
    "myChallenges": "Competities",
    "upcoming": "Aanstaande",
    "myPersonalGoals": "Doelen",
    "companyCompetitions": "Bedrijfscompetities",
    "communityCompetitions": "Community competities",
    "edit_your_team": "Bewerk uw team",
    "emails": "E-mails",
    "CompletedOverall": "Algemeen voltooid",
    "TotalEarned": "Totaal verdiend",
    "notify_header": "Ik wil graag op de hoogte worden gehouden:",
    "AdditionalBonus": "Extra bonus",
    "goalEndedNotification": "Doel is afgelopen, blijf uzelf pushen!",
    "compEndedNotification": "Competitie afgelopen, blijf uzelf pushen!",
    "congrats_tracking_first": "Gefeliciteerd met het bijhouden van u eerste activiteit!",
    "keep_tracking": "Blijf uw activiteit bijhouden om doelen te bereiken en een hoger niveau te bereiken.",
    "understanding_tracking": "Bijhouden begrijpen",
    "cannot_track_this_day": "U kan op deze dag niet volgen.",
    "nothing_tracked_this_day": "U hebt deze dag nog niet bijgehouden.",
    "tracked_something_this_day": "U hebt iets gevolgd voor deze dag.",
    "reached_goal_this_day": "U hebt uw doel voor deze dag bereikt (alleen voor dagelijkse doelen).",
    "got_it": "Begrepen!",
    "notDismissedMultiTitle": "Uitdaging samenvatting",
    "notDismissedMultiSubtitle": "Een paar uitdagingen zijn afgelopen. Kijk dieper in elk voor details over hoe u het deed.",
    "daySummary": "%{userName}, hier is een samenvatting van u dag tot nu toe",
    "goals": "Doelen",
    "competitions": "Competities",
    "totalAccumulated": "Totaal geaccumuleerd",
    "tracking_for_date": "Volgen voor %{date}",
    "activity_tracker_instruction": "Tap om een handmatig bijgehouden activiteit te bewerken of te verwijderen",
    "ended": "Eindigde",
    "notYetAvailableBeta": "Nog niet beschikbaar in bèta",
    "suggestedGoal": "Voorgesteld doel",
    "singleFor": "voor",
    "seeLessLongComment": "Zie minder",
    "synced_data": "gesynchroniseerde gegevens:",
    "doThisLater": "Ik zal dit later doen",
    "inviteUsers": "Nodig anderen uit om mee te doen",
    "cannotTrackAfterDeadline": "U probeert een activiteit bij te houden voor een datum na de challenge-deadline.",
    "potentialBonusPoints": {
        "section": {
            "title": "%{potentialBonusPoints} bonus %{customPoints} zijn beschikbaar voor dit doel!",
            "titleNotCompleted": "U hebt de %{potentialBonusPoints} bonus %{customPoints} met %{activitytCompletedPercentage}% gemist.",
            "titleCompleted": "Gefeliciteerd! u hebt verdiend",
            "titleCompletedBold": "%{potentialBonusPoints} bonus %{customPoints}!",
            "subtitle": "Meer informatie over bonus %{customPoints}"
        },
        "modal": {
            "title": "Bonus %{customPoints}",
            "desc1": "We weten dat niemand perfect is en doelen niet 100% van de tijd kan bereiken.",
            "desc2": "Daarom kennen we bonus %{customPoints} toe wanneer u algehele vooruitgang 85% of hoger is.",
            "desc3": "Alle bonus %{customPoints} worden toegekend nadat het doel is afgelopen en als al uw tracking afkomstig was van een verbonden app of apparaat, ontvang u een dubbele bonus %{customPoints}!",
            "desc4": "U ontvangt geen bonus %{customPoints} voor doelen die u te vroeg verlaat."
        },
        "msg": {
            "title": "Dit doel is afgelopen",
            "subtitle": "Doel eindigde op %{goalEndedDate}"
        },
        "msgEnded": {
            "title": "De tijd is om! Uw doel is afgelopen",
            "subtitle": "U hebt %{daysNum} %{daysOrDay} om u activiteit bij te houden."
        }
    },
    "finish": "Finish",
    "personalGoal": {
        "all_goals": {
            "selected": "Alle %{maxGoals} doelen gesteld!",
            "description": "Is dit naar uw zin? U kan alle doelen vervangen als u van gedachten verandert. Maak u geen zorgen, u kan u doel later ongedaan maken.",
            "set": "Alle doelen zijn gesteld!",
            "action": "Helemaal klaar, gereed om te gaan!",
            "error": "Laten we ons niet laten meeslepen! Door u op maximaal 3 gestructureerde doelen tegelijk te concentreren, vergroot u de kans op succes.",
            "errorHeading": "Doelen stellen"
        },
        "set_more": "U kan %{maxGoals} meer actieve doelen instellen",
        "select_goal": {
            "heading": "Stel een aanbevolen doel in of maak er zelf een"
        },
        "set_more_1": "U kan nog 1 actief doel instellen"
    },
    "restartPersonalGoal": "Doel opnieuw beginnen met nieuwe doelen",
    "delete_challenge_confirmation": "Weet u zeker dat u deze uitdaging wilt verwijderen?",
    "personal_goal_unit": "doel",
    "personal_goal_units": "doelen",
    "day_summary": {
        "steps_taken": "Stappen genomen",
        "calories_in": "Calorieën in",
        "calories_out": "Calorieën uit",
        "avg_daily": "gem. dagelijks",
        "most_earned_daily": "meest verdiend per dag"
    },
    "invitedBy": "Uitgenodigd door %{person}",
    "resetPasswordMissingField": "Voer een e-mailadres in",
    "resetPasswordInvalidValue": "Typ een geldig e-mailadres in",
    "resetPasswordNotFound": "Uw e-mailadres kan niet worden gevonden",
    "resetPasswordNotCompleted": "Uw verzoek kon niet worden voltooid",
    "resetGoalInstructions": {
        "start": "Doe %{quantity} %{units} van %{activity}",
        "additional": "%{quantity} %{units} van %{activity}",
        "end": "%{frequency} en verdien %{points} %{customPoints} %{frequency}"
    },
    "goalSet": {
        "one": "Eén doel gesteld. Bekijken",
        "two": "Twee doelen gesteld. Bekijken",
        "three": "Drie doelen gesteld. Bekijken",
        "none": "Geen doelen gesteld. Gestelde doelen"
    },
    "searchCommunitiesEmpty": "Geen community's gevonden",
    "searchCommunitiesPlaceholder": "Zoek community's",
    "updating": "Bijwerken...",
    "pts_tracked": "Bijgehouden %{activityName} - %{num} %{customPoints}",
    "improving_wellbeing_score": "Ga zo door, u bent onderweg om uw welzijnsscore te verbeteren.",
    "progressHistory": "Vooruitgang geschiedenis",
    "privateCommunity": "Dit is een privé community",
    "do_combo_of_activities": "Doe een combinatie van het volgende.",
    "noActivitiesTracked": "Geen activiteiten bijgehouden",
    "trackingWithFollowingApps": "Bijhouden met de volgende apps\/apparaten",
    "recommendedApps": "Aanbevolen apps\/apparaten voor deze %{challengeType}",
    "collapseWord": "Invouwen",
    "started": "Begonnen",
    "ends": "Eindigt",
    "do_activities": "Doe activiteiten",
    "rewards_placeholder": "Voorbeeldbeloningen uit de winkel, tijdelijke aanduiding. Gebruikers zien verschillende producten en de kosten in %{rewardName}.die ze kunnen kopen.",
    "personalGoals": {
        "top": {
            "label": "Top"
        },
        "allGoals": "Alle doelen",
        "seeMoreCard": {
            "heading": "Zie u niet wat u zoekt?",
            "description": "Bekijk alle aanbevolen doelen",
            "button": "Verken doelen"
        }
    },
    "rewardsNotAvailable": "Beloningen zijn momenteel niet beschikbaar in deze bèta. Indien beschikbaar, kan u de catalogus bekijken en een inwisseling voltooien.",
    "editProfileProvideRestingHeartRate": "Geef een geldige rusthartslagwaarde op van ten minste 40",
    "liveBetterHealthInfo": "We hebben een aantal programma's en hebben een verscheidenheid aan gezondheidsinhoud die is ontworpen om een reeks gezondheidsbehoeften te ondersteunen en u te helpen een betere gezondheid te bereiken. We hebben nog geen programma's voor elke gezondheidstoestand en behoefte – daar werken we aan! - als u echter de volgende vragen beantwoordt, nemen we contact met u op als we gezondheidsprogramma's of -diensten identificeren waar u mogelijk baat bij heeft door deel te nemen en\/of u op feiten gebaseerde informatie sturen die u zal helpen uw gezondheidsbehoeften beter te begrijpen en te beheren . Houd er rekening mee dat we deze informatie niet gebruiken om de geschiktheid van uw polis te beoordelen. Als u wilt weten waarvoor u gedekt bent of als u vragen heeft over uw polis, kan u contact opnemen met ons Customer Connect-team door ze te bellen op 132 331.",
    "deleteGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "U hebt het doel verwijderd"
        }
    },
    "deleteChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "U hebt de uitdaging verwijderd"
        }
    },
    "invitations": "Uitnodigingen",
    "learnMorePeriods": "Meer informatie over menstruatie",
    "tracked_by_app_name": "Bijgehouden door %{app_name}",
    "device_required": {
        "text": "Deze %{challengeType} vereist een app of apparaat",
        "button": "Verbind een app of apparaat"
    },
    "editingCommunityToast": {
        "success": {
            "title": "Community bewerken",
            "message": "Community is bewerkt"
        }
    },
    "competition": "Competitie",
    "close": "Dichtbij",
    "only_automatic_activities_with_device": "De activiteiten van deze %{goal_or_competition} worden automatisch bijgehouden met u verbonden apps\/apparaten.",
    "only_automatic_activity_with_device": "De activiteit van deze %{goal_or_competition} wordt automatisch bijgehouden met u verbonden apps\/apparaten.",
    "deletingCommunityToast": {
        "success": {
            "title": "%{name}",
            "message": "Community verwijderd"
        }
    },
    "teamSizeMessage": "U team heeft minimaal %{min} mensen nodig om %{customPoints} te verdienen voor de uitdaging.",
    "captain": "Kapitein",
    "inviteOthersToTeam": "Nodig anderen uit voor mijn team",
    "loadingMetrics": "Verbinding maken met bronnen om uw dag bij te werken...",
    "aboutTeamSize": {
        "title": "Team grootte",
        "text": "%{min} tot %{max}"
    },
    "pointsOverview": "%{customPoints} overzicht",
    "deepLinks": {
        "requestCouldNotBeCompleted": "Uw verzoek kon niet worden voltooid",
        "error": "Fout"
    },
    "required_lc": "vereist",
    "personal": "Persoonlijke gegevens",
    "biometrics": "Biometrie",
    "makeSelection": "Maak een selectie",
    "ask_question_success_msg": "Bedankt. We zullen zo snel mogelijk antwoorden.",
    "report_issue_success_msg": "Bedankt. We zullen zo snel mogelijk antwoorden.",
    "ask_question_success_title": "Vraag ingediend",
    "report_issue_success_title": "Technisch probleem ingediend",
    "ask_question_failure_msg": "Jammer... Er is een fout opgetreden bij het verzenden van uw vraag, probeer het opnieuw.",
    "report_issue_failure_msg": "Jammer... Er is een fout opgetreden bij het melden van uw probleem. Probeer het opnieuw.",
    "notTrackedActivities": "U hebt gedurende deze periode geen activiteiten bijgehouden",
    "learn": "Leren",
    "Balance": "Evenwicht",
    "details": "Details",
    "Reward": "Beloning",
    "levelsReset": "Niveaus gereset over %{remainingDays} dagen",
    "redeem": "Inwisselen",
    "redeemAt": "Inwisselen voor %{points}",
    "needPointsToRedeem": "U hebt nog %{points} %{rewardName} nodig.",
    "learnEarnMore": "Leer hoe u meer kan verdienen",
    "currency": "SproutBucks",
    "joiningTeamChallengeToast": {
        "success": {
            "title": "Word lid van het team",
            "message": "U bent succesvol lid geworden van het team!"
        },
        "danger": {
            "message": "Er is een fout opgetreden en we kunnen het team niet vinden. Het bestaat misschien niet meer."
        }
    },
    "NoMatchingDeepLinkToast": {
        "danger": {
            "title": "Actie niet beschikbaar",
            "message": "Uw verzoek kon niet worden voltooid."
        }
    },
    "transactionLog": "Transacties",
    "orderHistory": "Bestellingen",
    "pointsAvailableToEarn": "%{points} beschikbaar om te verdienen",
    "missedYTD": "%{missed} heeft JTD gemist",
    "rewardsDetails": "Beloningen",
    "successfullyRedeemedItem": "U hebt dit item succesvol ingewisseld",
    "orderNumber": "Bestellingsnummer",
    "amountSpent": "Bedrag uitgegeven",
    "status": "Status",
    "dateRedeemed": "Datum ingewisseld",
    "additionalInformation": "Extra informatie",
    "shipToAddress": "Verzenden naar dit adres",
    "pointMissedYearToDate": "%{rewardCurrencyName} dit jaar gemist",
    "pointMissedYearToDateDescription": "Als u geen niveau bereikt voordat de periode afloopt, wordt de bijbehorende %{rewardCurrencyName} die u had kunnen verdienen, als gemist beschouwd.",
    "NoLibraryContentToast": {
        "info": {
            "title": "Artikel niet gevonden",
            "message": "Kon artikel niet vinden. Mogelijk is deze verwijderd of niet meer beschikbaar."
        }
    },
    "CommunityNotFoundToast": {
        "danger": {
            "title": "Community niet gevonden",
            "message": "Kan community niet vinden. Mogelijk wordt deze verwijderd of niet meer beschikbaar."
        }
    },
    "shippingAddress": "Verzend-\/factuuradres",
    "enterShippingAddress": "Vul uw verzend-\/factuuradres in",
    "streetLine": "Straatlijn %{num}",
    "stateProvince": "Staat\/provincie",
    "postcodePostalcodeZip": "Postcode",
    "phoneNumber": "Telefoonnummer",
    "order": "Bestelling",
    "redemptionConfirmation": "Bevestiging van inwisseling",
    "edit": "Bewerken",
    "processing": "Verwerken",
    "checkIsYouFirst": "We moeten eerst controleren of u het bent",
    "discardSomeGoals": "U hebt een aantal doelen gesteld. Deze doelen worden verwijderd als u doorgaat.",
    "settingGoalsToast": {
        "success": {
            "message": "Uw nieuwe doelen zijn gesteld!"
        }
    },
    "one_team": "1 team",
    "noAchievementsToEarnMessage": "Het lijkt erop dat er deze periode geen badges meer zijn om %{rewardCurrencyName} te verdienen.",
    "shopRewards": "Winkel beloningen",
    "validateShippingAddressToast": {
        "danger": {
            "title": "Verzend-\/factuuradres",
            "message": "Vul alle velden in voordat u verder gaat."
        }
    },
    "viewDetails": "Details bekijken",
    "potential": "Potentieel",
    "missed": "Gemist",
    "rewardsStoreNotAvailable": "De beloningenwinkel is momenteel niet voor u beschikbaar.",
    "havent_tracked_in_a_while_date": "Geen activiteiten bijgehouden voor %{currentDate}",
    "challengeNotFoundToast": {
        "danger": {
            "title": "Uitdaging niet gevonden",
            "message": "Kan uitdaging niet vinden. Mogelijk is deze verwijderd of niet meer beschikbaar."
        }
    },
    "shareYourDaySubtitleActivity": "Voeg een foto toe of vertel iets over deze activiteit!",
    "goal_ended": "Doel afgelopen",
    "challenge_ended": "Uitdaging afgelopen",
    "day_remaining_to_track": "U hebt 1 dag om gemiste activiteiten bij te houden",
    "challengeGoalCardSubtitleEndDate": "%{challengeOrGoal} eindigde op %{endDate}",
    "goalEndedModal": {
        "title": "Vergeten activiteiten inhalen",
        "message": "Nadat een persoonlijk doel of uitdaging is afgelopen, hebt u vanaf de einddatum drie dagen de tijd om activiteiten bij te houden die u misschien bent vergeten. Na deze respijtperiode kan u geen aanvullende activiteiten bijhouden die bijdragen aan het doel of de uitdaging."
    },
    "summary": "Samenvatting",
    "placedRank": "U bent %{rank} geplaatst van %{total}",
    "rank": {
        "first": "1e",
        "second": "2e",
        "third": "3e",
        "n": "%{rank}e"
    },
    "event_name": "Evenement naam",
    "this_is": "Dit is een",
    "location_info": "Locatie & info",
    "what_event": "Waar gaat dit evenement over",
    "event_is": "Dit evenement is",
    "start_on": "Begin op:",
    "end_on": "Eindigt op:",
    "location": "Locatie",
    "chooseLeaderboard": "Selecteer een leaderboard",
    "filterOneOfFollowing": "Filter een van de volgende",
    "showChallengeInstead": "Toon in plaats daarvan een uitdaging",
    "showActivityInstead": "Toon in plaats daarvan een activiteit",
    "showAll": "Toon alles",
    "activitiesShowSame": "Activiteiten: %{activityName}",
    "challengeShowSame": "Uitdaging: %{challengeName}",
    "chooseTimePeriod": "Selecteer een tijdsperiode",
    "youCanFilterOneAtTime": "Er kan één filter tegelijk worden geselecteerd",
    "saveHealthTopicsToast": {
        "success": {
            "message": "Gezondheidsonderwerpen opgeslaan",
            "title": "Succes!"
        },
        "info": {
            "message": "Kan niet worden opgeslaan"
        },
        "danger": {
            "title": "Fout!"
        }
    },
    "saveHealthObjectivesToast": {
        "success": {
            "message": "Gezondheidsdoelen opgeslaan",
            "title": "Succes!"
        },
        "info": {
            "message": "Kan niet worden opgeslaan"
        },
        "danger": {
            "title": "Fout!"
        }
    },
    "saveInterestGroupsToast": {
        "success": {
            "message": "Interesses opgeslaan",
            "title": "Succes!"
        },
        "info": {
            "message": "Kan niet worden opgeslaan"
        },
        "danger": {
            "title": "Fout!"
        }
    },
    "edit_event": "Evenement bewerken",
    "leave": "Verlaten",
    "delete_event": "Gebeurtenis verwijderen",
    "no_events": "Geen evenementen",
    "no_events_placeholder": "U bent momenteel niet van plan toekomstige evenementen bij te wonen. Waarom sluit u uw niet aan?",
    "event": "evenement",
    "challenge": "Uitdaging",
    "invited_you": "U uitgenodigd",
    "public": "Openbaar",
    "private": "Privé",
    "deleteEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Evenement succesvol verwijderd."
        }
    },
    "leaveEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "U hebt het evenement verlaten"
        }
    },
    "editEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Evenement succesvol bijgewerkt."
        }
    },
    "createEventToast": {
        "success": {
            "message": "Evenement succesvol aangemaakt.",
            "title": "%{eventName}"
        }
    },
    "contentIsDeletedOrInappropriate": "De inhoud die u probeert te bekijken, is momenteel niet beschikbaar. Het is mogelijk verwijderd door de auteur of gemarkeerd als ongepast.",
    "start_time": "Begintijd",
    "end_time": "Eindtijd",
    "event_type": "%{eventType} evenement",
    "leave_event_modal": {
        "title": "Als u dit evenement verlaat",
        "message": "wordt het verwijderd"
    },
    "leave_event ": "Weet u zeker dat u dit evenement wilt verlaten?",
    "create_event": "Maak evenement",
    "created_by": "Gemaakt door",
    "eventActionToast": {
        "danger": {
            "title": "Fout",
            "message": "Er is iets fout gegaan."
        }
    },
    "continue": "Doorgaan",
    "wantExitTour": "Weet u zeker dat u de tour wilt verlaten?",
    "exitTour": "Tour verlaten",
    "deleveEventPopup": "Weet u zeker dat u dit evenement wilt verwijderen?",
    "attendeesTitle": "Deelnemers",
    "userEvents": "%{name}'s evenementen",
    "createEventIndicator": "Evenement aanmaken",
    "inviteToEvent": "Nodig uit voor evenement",
    "noDescription": "Er is geen beschrijving.",
    "leaderboardIsEmpty": "Dit leaderboard is leeg of u moet mogelijk activiteiten bijhouden binnen de geselecteerde tijdsperiode om het ze te bekijken",
    "notParticipantingInAnyChallenges": "u doet niet mee aan uitdagingen",
    "buttonLeaveEvent": "Evenement verlaten",
    "leaveEvent ": "%{name} verlaten?",
    "canceledCreatingChallenge": "Het maken van een %{challengeType} is succesvol geannuleerd",
    "swipeReadNotification": "Lezen",
    "productTour": {
        "initialScreen": {
            "title": "Welkom bij %{programName}!",
            "body": "Laten we een rondleiding nemen en binnen enkele ogenblikken ken u de basis."
        },
        "dashboard": {
            "title": "Dashboard",
            "body": "Bekijk hoeveel %{pointsName} u hebt en uw vooruitgang naar niveaus. Bekijk dan het leaderboard om te zien hoe u scoort."
        },
        "rewards": {
            "title": "Beloningen",
            "body": "Bekijk hoeveel %{rewardPointName} u hebt en wissel ze in in de winkel."
        },
        "goals": {
            "title": "Doelen & uitdagingen",
            "body": "Uw actieve persoonlijke doelen, Uitdagingen met anderen en speciale taken zijn hier te vinden."
        },
        "explore": {
            "title": "Ontdekken",
            "body": "Zoek uitdagingen met anderen, sluit u aan bij community's om u interesses te bespreken en ontdek een nieuw artikel in de welzijnsbibliotheek."
        },
        "me": {
            "title": "Me",
            "body": "Vind hier uw welzijnsscore, controleer uw statistieken en bewerk uw profiel en instellingen."
        },
        "finishScreen": {
            "title": "U bent klaar",
            "body": "Bedankt voor het voltooien van de rondleiding.",
            "button": "Laten we beginnen"
        },
        "skip": {
            "title": "Weet u zeker dat u de tour wilt overslaan?",
            "body": "Hiermee beëindigt u de tour en kan u direct aan de slag."
        }
    },
    "getTemporaryRewardRedemptionTokenToast": {
        "danger": {
            "title": "Authenticatie fout",
            "message": "Kan niet doorgaan met het inwisselen van beloningen. Er is een fout opgetreden tijdens het verifiëren bij de beloningsprovider."
        }
    },
    "rewardRedemptionFailureToast": {
        "danger": {
            "title": "Inwisselen mislukt",
            "message": "%{displayMessage}"
        }
    },
    "disclamerSectionTitle": "Voordat u begint",
    "disclamerSectionMessage": "Raadpleeg uw zorgverlener voordat u met een nieuw oefeningsprogramma begint of veranderingen in uw levensstijl aanbrengt om er zeker van te zijn dat deze geschikt zijn voor u.",
    "noEarchedAchievements": "U hebt nog geen prestaties verdiend. Volg een activiteit om aan de slag te gaan.",
    "noInProgressAchievements": "U hebt geen prestaties aan de gang.",
    "discardCreatingEventMessage": "Controleer of alle verplichte velden zijn ingevuld",
    "discardCreatingEventTitle": "Evenement kan niet worden gemaakt",
    "discardEditedEventTitle": "Evenement kan niet worden bewerkt",
    "errorEventNameMessage": "Naam is vereist",
    "errorEventStartDateMessage": "Begindatum is vereist",
    "errorEventEndDateMessage": "Einddatum is vereist",
    "errorEventDateMessage": "De einddatum kan niet eerder zijn dan de begindatum",
    "noAccountsToLink": "Er zijn geen accounts beschikbaar om te koppelen aan %{program_name}.",
    "accountLinkEmailChanged": "Uw e-mailadres is bijgewerkt. Log in de toekomst in met uw gekoppelde account.",
    "accountLinkSuccessful": "Uw account is succesvol gekoppeld.",
    "edit_profile_nan_value": "De waarde moet een getal zijn",
    "advancedLogIn": "Geavanceerd inloggen",
    "redemptionSessionExpiredToast": {
        "danger": {
            "title": "Inwisselen mislukt",
            "message": "Bestelsessie is verlopen. Probeer de bestelling opnieuw te plaatsen."
        }
    },
    "left": "vertrokken",
    "eventsCarousel": {
        "emptyEvent": {
            "prompt": "Het lijkt erop dat er op dit moment geen evenementen beschikbaar zijn om aan deel te nemen. Waarom maakt u er geen?"
        }
    },
    "reachedHighestLevel": "U hebt het hoogste niveau bereikt!",
    "error": "Fout",
    "redeemRewardSuccessfulToast": {
        "success": {
            "title": "Beloning inwisselen",
            "message": "Uw bestelling is geplaatst"
        }
    },
    "redeemRewardComplete": "Inwisseling voltooid",
    "trackActivityTitle": {
        "oneUnit": "Volg: 1 %{unit} van %{activity} op %{date}",
        "nUnit": "Volg: %{activity} voor %{date}"
    },
    "ssoAuthenticationFailure": "Authenticatie fout",
    "earnEvery": "Verdien elke %{frequency}",
    "earnOnce": "Verdien eenmalig",
    "goalSettings": {
        "maximumSet": "U hebt momenteel het maximum van 3 doelen ingesteld.",
        "learnMore": "Meer informatie over het stellen van doelen"
    },
    "allowMarketingComms": "Stuur me promotionele communicatie",
    "allowPartnerMarketingComms": "Stuur me promotionele communicatie van partners",
    "noUpcomingAchievements": "U hebt geen aankomende prestaties.",
    "settingGoalToast": {
        "success": {
            "message": "Uw nieuwe doel is gesteld!"
        }
    },
    "authentication": {
        "saml": {
            "error": "Service momenteel niet beschikbaar",
            "signin": "Geïntegreerd inloggen",
            "signup": "Geïntegreerd aanmelden"
        }
    },
    "monthName": {
        "january": "januari",
        "february": "februari",
        "march": "maart",
        "april": "april",
        "may": "mei",
        "june": "juni",
        "july": "juli",
        "august": "augustus",
        "september": "september",
        "october": "oktober",
        "november": "november",
        "december": "december"
    },
    "promotedForMe": "Aanbevolen",
    "appRating": {
        "enjoying": "Geniet u van onze app?",
        "feedback": "Wil u wat feedback geven?",
        "appStore": "Beoordeel ons in de App Store?",
        "googlePlay": "Beoordeel ons op Google Play?",
        "notReally": "Niet echt",
        "yes": "Ja!",
        "sure": "Zeker",
        "noThanks": "Nee bedankt",
        "notNow": "Niet nu"
    },
    "getMobileApp": "Om %{programName} op uw smartphone te gebruiken, downloadt u %{appStoreName} uit de App Store of uit Google Play.",
    "newAppsDevicesDesign": {
        "getMobileApp": "Download de %{programName}-app",
        "searchInAppStore": "Zoek naar %{programName} in de app store van uw apparaat",
        "getMobileAppNoName": "Neem de mobiele app"
    },
    "editorAlert": {
        "discardChanges": "Veranderingen ongedaan maken",
        "saveAndContinue": "Opslaan en doorgaan",
        "title": "Niet-opgeslagen wijzigingen",
        "text": "U heeft enkele wijzigingen aangebracht die niet zijn opgeslaan. Wat wil u doen?"
    },
    "resources": "Bronnen",
    "noResources": "Geen bronnen beschikbaar",
    "viewAllResources": "Bekijk alle bronnen",
    "language": "Taal",
    "eventStarted": "Evenement begonnen. Registratie gesloten.",
    "Gender": "Geslacht",
    "show": "Toon",
    "hide": "Verberg",
    "timeoutError": "Oeps! Iets duurt te lang. Probeer het later opnieuw.",
    "SOT": {
        "sample_task": "Voorbeeldtaak"
    },
    "cache": {
        "new_version": "Er is een nieuwe versie beschikbaar!",
        "refresh_browser": "Klik hier om uw browser te vernieuwen."
    },
    "welcomeUser": "Welkom, %{userFirstName}!",
    "quarter": "kwartaal",
    "completionReward": "Voltooiingsbeloning",
    "bronzeLevel": "Bronzen niveau",
    "deviceAppSyncingOk": "Synchronisatie van apparaat\/app ok",
    "deviceAppSyncingIssue": "Probleem met synchronisatie van apparaat\/app",
    "deviceAppSyncingError": "Synchronisatiefout apparaat\/app",
    "lastSync": "Laatste synchronisatie",
    "period": "periode",
    "yourDaySummary": "Uw dag tot nu toe",
    "steps": "Stappen",
    "gender_non_binary": "Non-binary of non-conforming",
    "take_survey": "De enquete invullen",
    "social": "Sociaal",
    "finalDay": "Laatste dag",
    "leaderboard_position": "Leaderboard positie",
    "signUp": {
        "apple": {
            "disconnectSettings": "Ontkoppel %{appName} van 'Apple ID Wachtwoord & Beveiliging' in Telefoon instellingen om door te gaan met aanmelden"
        }
    },
    "earnPoints": "Verdien %{customPoints}. Ge een niveau omhoog.",
    "getReward": "Ontvang %{rewardName}.",
    "buildHealthyHabits": "Bouw gezonde gewoontes op.",
    "highestLevelIndicator": "U hebt het hoogste niveau bereikt!",
    "highestLevelIndicatorNew": "Je hebt alle niveaus voltooid!",
    "trackYourActivity": "Om %{customPoints} te krijgen, houdt u uw trainings- en welzijnsactiviteit bij.",
    "levelUpToGetRewarded": "Naarmate u hoger komt, word u beloond met %{rewardName}.",
    "levelUpAndEarn": "Uw vooruitgang wordt elke %{period} gereset, dus u kan steeds weer een niveau omhoog gaan en geld verdienen.",
    "levelUp": "Uw vooruitgang wordt elke %{period} gereset, zodat u steeds weer een hoger niveau kan bereiken.",
    "goToLibrary": "Ga naar de bibliotheek",
    "updateEventIndicator": "Evenement bijwerken",
    "meTour": {
        "healthSurveyDisabled": "Controleer hier uw statistieken en bewerk uw profiel en instellingen."
    },
    "createNewGoal": "Maak een nieuw doel",
    "later": "Later",
    "bonusChallenge": "Bonusuitdaging",
    "bonusChallengeInfo": {
        "withReward": "U verdient %{amount} bonus %{points} voor het voltooien van ten minste 85% van deze %{challengeType}.",
        "noReward": "U verdient een bonus voor het voltooien van ten minste 85% van deze uitdaging.",
        "boldText": "%{amount} bonus %{points}",
        "noRewardChallengeType": "U verdient een bonus voor het voltooien van ten minste 85% van deze %{challengeType}."
    },
    "defaultApp": "Uw standaard gezondheidsapp",
    "bonusGoal": {
        "additionalInfo": "Als al u activiteit is bijgehouden met een verbonden app of apparaat, ontvang u een dubbele bonus %{points}!",
        "additionalInfoNew": {
            "paragraph2": "Bonus %{points} worden toegekend nadat het doel is afgelopen. U ontvangt geen bonus %{points} voor doelen die u te vroeg verlaat."
        },
        "boldText": "dubbele bonus %{points}!",
        "markTitle": "Bonusdoel"
    },
    "notify_me": "Breng mij op de hoogte",
    "bonusChallengeReward": "Bonus uitdagingsbeloning",
    "forCompletingChallenge": "Voor het voltooien van %{challengeName}",
    "notifications_text": "Meldingen helpen u om u aan uw doelen te houden en gesprekken bij te houden.",
    "type_here": "Typ hier",
    "bonusEarned": "Bonus verdiend",
    "youEarnedBonus": "U hebt deze bonus verdiend!",
    "inviteOthersToChallenge": "Nodig anderen uit om mee te doen aan de uitdaging",
    "inviteOthersToYourTeam": "Nodig anderen uit voor uw team",
    "manageTeam": "Team beheren",
    "ft": "ft",
    "lbs": "pond",
    "cm": "cm",
    "kg": "kg",
    "community": "community",
    "chooseActivity": "Selecteer activiteit",
    "Recent": "Recent",
    "noActivities": "Geen overeenkomende activiteiten",
    "photoChooseText": "Selecteren",
    "photoCancelText": "Annuleren",
    "signIn": {
        "missingEmail": "Ontbrekend e-mailadres",
        "missingPassword": "Zorg ervoor dat het wachtwoord wordt verstrekt",
        "invalidLogin": "Ongeldige login",
        "accountLocked": "Uw account is geblokkeerd. Neem contact op met uw beheerder",
        "accountMayNotExist": "We hebben geen account voor dit e-mailadres. Meld u aan om een account aan te maken.",
        "wrongPassword": "Verkeerd wachtwoord. Probeer het nogmaals en klik op Wachtwoord Vergeten om opnieuw in te stellen."
    },
    "deleteGoalBonusPoints": "Als u de bijbehorende bonus nog niet hebt verdiend, kan u dat niet meer doen.",
    "havent_tracked_goal": "U hebt geen activiteiten voor dit doel gevolgd",
    "trackActivity": {
        "search": "Activiteiten zoeken...",
        "text": "Volg activiteit",
        "done": "Klaar",
        "discardChanges": "Veranderingen ongedaan maken?",
        "discardMessage": "Weet u zeker dat u wilt afsluiten en u vooruitgang wilt negeren?",
        "discard": "Verwijderen",
        "limitMessage": "U kan maximaal zeven dagen tegelijk volgen.",
        "inputDescription": "Hoeveelheid %{activity} voor %{date}",
        "gracePeriod": "U hebt %{n} %{text} om gemiste activiteiten te volgen"
    },
    "dates": "Datums",
    "pickDates": "Kies andere datums",
    "selectDates": "Selecteer datums",
    "limitReached": "U hebt de limiet bereikt",
    "activity": "Activiteit",
    "keepUpTheGoodWork": "Ga zo door!",
    "activityTracked": "Activiteit gevolgd",
    "new": "Nieuw",
    "newFeatureTitle": "Gemakkelijker en sneller volgen van activiteiten",
    "newFeatureText": "Of u nu activiteiten van vandaag, van het verleden of van meerdere dagen volgt, we denken dat u deze nieuwe ervaring geweldig zult vinden.",
    "gotIt": "Begrepen!",
    "frequencyViewHistory": "Bekijk %{frequency} uitsplitsing",
    "challengeDetails": {
        "trackTheseActivities": "Volg elk van deze activiteiten om vooruitgang te boeken in de richting van deze %{challengeType}."
    },
    "member": "lid",
    "weeklyBreakdown": "Wekelijkse uitsplitsing",
    "setGoals": {
        "earnPointsText": {
            "start": "Verdienen",
            "end": "voor het stellen van u eerste doel!"
        }
    },
    "weeklyGoalEnded": "Week eindigde op",
    "weekFinished": "U hebt een week volbracht",
    "restartGoal": {
        "daysLeftToTrack": "U hebt nog steeds %{quantity} %{days} om eventuele vergeten vorderingen van vorige week te volgen.",
        "weekEnded": "Deze week is afgelopen.",
        "timesUp": "De tijd is om!",
        "period": {
            "title": "Doelperiode",
            "text": "Maandag t\/m zondag, elke week"
        }
    },
    "membersPlural": "Leden",
    "startedADayAgo": "1 dag geleden begonnen",
    "goalRestarted": "u hebt dit doel opnieuw begonnen",
    "weeklyGoals": "Wekelijkse doelen",
    "weeklyGoalsDescription": "Wekelijkse doelen vernieuwen zichzelf elke maandag, zodat u een gezonde gewoonte gedurende een lange periode kan volhouden.",
    "challengeEnded": "Deze %{challengeType} is afgelopen",
    "goalEndedModalTitle": "De tijd is om! Uw %{challengeType} is afgelopen!",
    "yourProgress": "Uw vooruitgang",
    "earn_withRewards": "Houd uw gezonde activiteit bij om (%{pts}) te verdienen en niveaus te behalen. Als je een level omhoog gaat, ontvang je %{currency}.",
    "earn_noRewards": "Suivez votre exercice et votre activité de bien-être pour gagner (%{pts}) et passer au niveau supérieur.",
    "currentPeriod": "Huidige periode",
    "currentScore": "Huidige score",
    "viewActivityLog": "Activiteitenlog bekijken",
    "balanceHistory": "Mijn balanshistorie",
    "mymedibank": {
        "underAge": {
            "error": "De Live Better-app is alleen beschikbaar voor gebruikers van 18 jaar en ouder. Raadpleeg de Live Better-voorwaarden voor meer informatie."
        }
    },
    "enhancedHomePageInfo": "We hebben de startpagina opgeruimd! Het is nu gemakkelijker om uw uitdagingen en doelen te zien. Tijd om te volgen!",
    "levelUpTitle": "Ga een niveau omhoog",
    "levelUpDescription": "Bereik niveaus door activiteiten te volgen en doelen en uitdagingen te voltooien. Naarmate u hoger komt, word u beloond met %{currency}!",
    "achievementsDescription": "Ontgrendel deze speciale badges om %{currency} te verdienen. Klik op een badge om te zien wat u moet doen.",
    "bonusChallengesDescription": "Doe mee en voltooi uitdagingen met een %{currency} bonus.",
    "earnWithPartners": {
        "title": "Verdien met partners",
        "description": "Medibank-leden met een dekking ziekenhuis of extra's kunnen punten verdienen op in aanmerking komende aankopen\/activiteiten bij partners."
    },
    "browseAllPartners": "Blader door alle partners",
    "resetsIn": "Reset over %{daysNumber} dagen",
    "thisIsALot": "Dit is veel!",
    "areYouSure": "Weet u het zeker?",
    "trackingALotMessage": {
        "days": "U volgt meer dan 2000 %{customPoints} op %{daysNum} dagen. Dat is best veel!",
        "day": "U registreert meer dan 2000 %{customPoints} op 1 dag. Dat is best veel!"
    },
    "amSure": "Ik ben er zeker van",
    "activeMinutesAndSleep": {
        "title": "Device tracking voor actieve minuten en slaap",
        "description": "Uw apparaat registreert actieve minuten tijdens fysieke activiteit van matige of hoge intensiteit: Dat is goede kwaliteit oefening! Gebruik u een apparaat om u slaap bij te houden? Daar verdien u ook %{points} voor!"
    },
    "hourShort": "uur",
    "hoursShort": "uur",
    "secondsShort": "sec",
    "watchToEarn": "Kijk om te verdienen",
    "oneParticipant": "1 deelnemer",
    "oneTeam": "1 Team",
    "numberOfTeams": "%{num} teams",
    "inviteToYourTeam": "Nodig uit voor uw team",
    "inviteToThisChallenge": "Nodig uit voor deze uitdaging",
    "challengeInstructionText": "Volg deze activiteit om vooruitgang te boeken onderweg naar uw %{challengeType}.",
    "showLess": "Toon minder",
    "startsTomorrow": "Begint morgen",
    "deadlineDayLeft": "overige dag",
    "deadlineDaysLeft": "overige dagen",
    "deviceBonus": "apparaatbonus",
    "appsAndDevices": {
        "header": "Apps en apparaten",
        "linked": "Deze gekoppelde apps en apparaten volgen naar deze %{challengeType}:",
        "noLinked": "Geen toepasselijke apps of apparaten gekoppeld",
        "link": "Koppel u telefoon, horloge of app om automatisch te volgen."
    },
    "yourGoals": "Uw doelen",
    "yourChallenges": "Je uitdagingen",
    "position": "Positie",
    "team_success": "Team succes",
    "starts_in": "Begint over",
    "team_challenge": "Teamuitdaging",
    "your_progress_today": "Uw vooruitgang vandaag",
    "your_daily_avarage": "Uw daggemiddelde is",
    "this_week_progress": "De vooruitgang van deze week",
    "this_month_progress": "De vooruitgang van deze maand",
    "overall_progress": "Algehele vooruitgang",
    "complete": "voltooid",
    "overallSuccess": "Algehele succes",
    "teamSuccessAverage": "Teamsucces gemiddeld",
    "progressDetails": "Vooruitgangsdetails",
    "dayStreak": "%{n} dagen streak!",
    "weekStreak": "%{n} weken streak!",
    "dailyProgress": "Dagelijkse vooruitgang",
    "participantsSuccessCount": {
        "overall": "%{amount} van %{total} deelnemers heeft het doel bereikt",
        "day": "%{amount} van %{total} deelnemers heeft vandaag het doel bereikt",
        "week": "%{amount} van %{total} deelnemers heeft deze week het doel bereikt",
        "month": "%{amount} van %{total} deelnemers heeft deze maand het doel bereikt"
    },
    "doubleBonusShort": "Dubbele bonus!",
    "doubleBonusLong": "U hebt een dubbele bonus verdiend!",
    "recommendedGoalDescription": "Doelen helpen u om u vooruitgang te volgen en gemotiveerd te blijven!",
    "noParticipation": "Geen deelname",
    "nothingToShow": "Het lijkt erop dat er nu niets te zien is",
    "yourTeam": "Uw team",
    "no_activity_title": "Geen activiteit",
    "brandSupport": {
        "description": "We hebben ondersteuning toegevoegd voor het synchroniseren van activiteiten met smartwatches van Polar en Withings. Tijd om in beweging te komen!"
    },
    "no_tracked_activities": "U hebt nog geen activiteiten gevolgd.",
    "button_leave_community": "Verlaat de community",
    "button_delete_challenge": "Verwijder %{challengeType}",
    "button_delete_community": "Community verwijderen",
    "button_delete_activity": "Activiteit verwijderen",
    "library_header_description": "Originele inhoud om u te onderwijzen, te betrekken en te inspireren tijdens uw wellnessreis.",
    "library_searchbar": "Zoek in de bibliotheek…",
    "library_page_header": "Originele inhoud om u te onderwijzen, te betrekken en te inspireren tijdens uw wellnessreis.",
    "onboarding_button_title": "Ik ben klaar",
    "refresh_bar": "Klik hier om te updaten",
    "content": {
        "min_read": "%{readingTime} minuten gelezen"
    },
    "noMembers": "Geen leden",
    "saved": "Opgeslaan",
    "forYou": "Voor u",
    "min read (Note: min as in minutes)": "",
    "send me program related email notifications": "",
    "send me weekly email updates": "",
    "you can earn this bade once every quarter": "",
    "badgeInstruction": "%{badgeInstruction} door",
    "youCanEarnThisBadge": "U kan deze badge eenmaal per %{period} verdienen",
    "emailPreferences": "E-mail voorkeuren",
    "unsubscribeText": "Schrijf u uit voor alle e-mailupdates",
    "savingText": "Opslaan...",
    "wrongTryLater": "Er is iets fout gegaan. Probeer het later opnieuw.",
    "preferencesSaved": "Voorkeuren opgeslaan",
    "recommendedForYou": "Aanbevolen voor u",
    "formerMember": {
        "label": "Voormalig lid"
    },
    "selectionsFromLibrary": "Selecties uit onze bibliotheek speciaal voor u gekozen",
    "goalsInfo": {
        "desc1": "om u te concentreren op het verbeteren van uw welzijn",
        "desc2": "U hebt het maximale aantal doelen ingesteld."
    },
    "createMyOwn": "Maak mijn eigen",
    "isAllSet": "is helemaal klaar!",
    "undoLabel": "Ongedaan maken",
    "terms": "Voorwaarden",
    "placeOrder": "Plaats bestelling",
    "item": "Item",
    "redeemFor": "Inwisselen voor",
    "confirmYourOrder": "Bevestig u bestelling",
    "orderComplete": "Bestelling voltooid",
    "redeemedFor": "Ingewisseld voor",
    "orderDetails": "Besteling gegevens",
    "bonusGoalReward": "Bonusdoel beloning",
    "orderSummary": "Overzicht van de bestelling",
    "logoutSSO": {
        "title": "U heeft zich afgemeld bij %{programName}.",
        "description": "Zie u binnenkort weer!",
        "signinAgain": "Klik hier om opnieuw in te loggen"
    },
    "nothing_to_show": "Er is nu niets te zien",
    "no_saved_content": "U hebt geen opgeslagen inhoud",
    "restarts_every_week": "Elke week opnieuw opstarten",
    "myGoals": "Mijn doelen",
    "goalGallery": "Doel gallery",
    "share_smth": "Iets delen…",
    "newFeatureModal": {
        "smartGoal": {
            "title": "Ons stappendoel is zojuist slimmer geworden!",
            "description": "Uw weken zijn altijd anders - nu zijn uw doelen dat ook! \n  Met de Smart-modus past u stappendoel zichzelf aan op basis van u dagelijkse activiteit.\n  Het is ingesteld met uw succes en welzijn in gedachten.",
            "action": "Bekijken!"
        },
        "mePage": {
            "title": "De nieuwe ik",
            "description": "We hebben de sectie 'Ik' opnieuw ontworpen om het vinden van de dingen die u belangrijk vindt gemakkelijker te maken - Bekijk het!",
            "letsSeeBtn": "Laten we eens kijken!",
            "llaterBtn": "Misschien later"
        },
        "bellEAP": {
            "title": "Welkom bij ons online platform programma Assistentie voor Medewerkers en Familie!",
            "description": "Ontdek de tools en diensten ter ondersteuning van welzijn en levensuitdagingen die voor jou en in aanmerking komende familieleden beschikbaar zijn",
            "button": "Maak nu verbinding of ga wanneer je maar wilt naar de pagina Snelle Koppelingen"
        },
        "quickActivityLogView": {
            "title": " Een snellere manier om uw recente activiteit te bekijken",
            "description": "U kunt nu op de voortgangsbalk klikken om uw activiteitenlogboek te bekijken."
        }
    },
    "goalSmartMode": {
        "title": "Smart-modus",
        "description": "Ontvang gepersonaliseerde wekelijkse doelen op basis van uw recente activiteitsniveau.",
        "status": "Smart-Modus is %{status} voor dit doel.",
        "infoModal": {
            "descriptionOne": "Wanneer de Smart-modus is ingeschakeld, verandert het doel voor dit doel van week tot week op basis van uw recente activiteitsniveau.",
            "descriptionTwo": "We zullen u precies genoeg uitdagen om u klaar te stomen voor succes.",
            "instructions": ""
        },
        "settings": {
            "switch": "Schakel de Smart-modus in voor mijn stappendoel",
            "description": "Als de Smart-modus is ingeschakeld, ontvang u aan het begin van elke week een nieuw stappendoel."
        },
        "enableSmartMode": "Schakel de Smart-modus in",
        "settingsModal": {
            "descriptionTurnOn": "Uw stappendoel verandert elke week op basis van u activiteit",
            "descriptionTurnOff": "Uw stappendoel wordt niet meer elke week gepersonaliseerd"
        }
    },
    "On": "In",
    "Off": "Uit",
    "top_posts": "Top posts",
    "most_recent": "Meest recente",
    "browseByTopic": "Blader op onderwerp",
    "video": "Video",
    "enable": "Inschakelen",
    "turnOff": "Uitschakelen",
    "new_post": "Nieuwe post",
    "new_post_in": "Nieuwe post in",
    "dailyTarget": "Dagelijks doel",
    "dailyTargetForWeek": "Dagelijks doel voor de week",
    "showMyActivityLog": "Toon mijn activiteitenlogboek",
    "usersReacted": {
        "oneOther": "%{userName} en 1 andere",
        "multipleOthers": "%{userName} en %{count} anderen"
    },
    "reactionsModal": {
        "title": "Meer manieren om te vieren",
        "description": "Moedig u collega's aan met nieuwe social post reacties!"
    },
    "account": "Account",
    "myWellbeingProfile": "Mijn welzijnsprofiel",
    "physicalDetailsDescription": "Deze informatie is nodig om uw welzijnsscore te berekenen",
    "wellbeingInterests": "Welzijn interesses",
    "myWellbeingInterests": "Mijn welzijnsinteresses",
    "preferredNameOptional": "Voorkeursnaam (optioneel)",
    "basicPhysicalDetails": "Fysieke basisgegevens",
    "notRegistered": {
        "infoModal": {
            "title": "We kunnen je niet vinden",
            "notInSystem": "zit niet in ons systeem.",
            "correctEmail": "Gebruik de juiste account (gewoonlijk een zakelijk e-mailadres) en let op tikfouten.",
            "emailHelp": "Stuur voor meer hulp een e-mail naar ons ondersteuningsteam op"
        }
    },
    "dontHaveAccount": "Heb je geen account?",
    "wasThisHelpful": "Was dit nuttig?",
    "healthScoreFeedbackModal": {
        "emojiSection": "Hoe nuttig is deze pagina en hoe nuttig is je welzijnsscore?",
        "commentSectionText": "Hoe kan het verbeterd worden?",
        "commentSectionPlaceholder": "Voeg een opmerking toe...",
        "thankYouModal": "Bedankt voor je feedback!"
    },
    "number_connected": "%{numDevices} verbonden",
    "searchPlaceHolder": "Zoeken...",
    "noTeamsFound": "Geen teams gevonden",
    "join_a_challenge": "Doe mee aan een uitdaging",
    "me_page_titles": {
        "goal": {
            "singular": "doel",
            "plural": "doelen"
        },
        "challenge": {
            "singular": "uitdaging",
            "plural": "uitdagingen"
        }
    },
    "seeMoreText": "...meer bekijken",
    "adjust_entry": "Pas de invoer aan.",
    "overTracking": {
        "title": "Waarschuwing voor over-tracking",
        "desc1": {
            "singular": "Deze invoer wordt gecontroleerd.",
            "plural": "Deze invoeren worden gecontroleerd."
        },
        "desc2": "Opzettelijk over-tracking kan leiden tot opschorting van account.",
        "button_edit": "Bewerk mijn invoeren",
        "button_confirm": "Indienen zoals het is"
    },
    "oneEventAttendee": "1 deelnemer",
    "multipleEventAttendees": "%{num} deelnemers",
    "to": "aan",
    "eventBonusFull": "Je verdient %{number} bonus % {points} voor het bijwonen van dit evenement.",
    "eventBonusBold": "%{number} bonus %{points}",
    "didYouLikeArticle": "Vond je dit artikel leuk?",
    "didYouLikeVideo": "Vond je deze video leuk?",
    "tellUsMore": "Vertel ons meer...",
    "thanksForFeedback": "Bedankt voor je feedback!",
    "challengesSubtitle": "Streef samen met andere deelnemers naar een doel - of speel om te winnen!",
    "appStoreNameSprout": "Sprout at Work",
    "appStoreNameLiveBetter": "Medibank Live Better",
    "appStoreNameTelus": "TELUS Gezondheid Welzijn",
    "huaweiStoreUrlSprout": "https:\/\/appgallery.huawei.com\/app\/C104993765",
    "telusHealthVirtualCare": "Telus Gezondheid Virtuele Zorg",
    "virtualCare": "Virtuele zorg",
    "changePassword": {
        "telus": {
            "info": "Je wachtwoord wordt beheerd via je %{telusVC} account.",
            "button": "Wijzig mijn %{virtualCare} wachtwoord"
        }
    },
    "actions": "handelingen",
    "onAndUpcoming": "Binnenkort",
    "termsAndPrivacyPolicyNew": "Door verder te gaan, ga je akkoord met de",
    "invitedToTeam": "Uitgenodigd door het team van %{firstName} %{lastName}",
    "decline": "Weigeren",
    "invitedToChallenge": "Uitgenodigd door %{firstName} %{lastName}",
    "goalsCard": {
        "emptyStateTitle": "Je hebt geen doelen ingesteld"
    },
    "huaweiStoreUrlTelus": "https:\/\/appgallery.huawei.com\/app\/C107357173",
    "challengesCard": {
        "emptyStateTitle": "Je bent in geen enkele uitdaging",
        "buttonLabel": "Uitdagingen verkennen"
    },
    "menu": "Menu",
    "everyone": "Allen",
    "confirmEmployeeID": "Bevestig medewerkers-id",
    "employeeIDNoMatch": "Deze id's komen niet overeen",
    "hidePost": "Verberg publicaties van %{ownerName}",
    "hidingUserPostToast": {
        "success": {
            "title": "Verborgen gebruiker",
            "message": "Je ziet geen publicaties meer van deze gebruiker."
        }
    },
    "moderateHideUserDescription": "Door publicaties van deze gebruiker te verbergen wordt gebruikersspecifieke content uit de stream verwijderd.",
    "startsInOneDay": "Begint over 1 dag",
    "endsInOneDay": "Eindigt over 1 dag",
    "endsToday": "Eindigt vandaag",
    "hrisEmployeeID": {
        "infoModal": {
            "notInSystem": "zit niet in ons systeem. Heb je het juist ingevoerd?",
            "administrator": "Als je een nieuwe medewerker bent, hebben we misschien je medewerkers-id nog niet. Vraag aan je beheerder wanneer je het opnieuw kunt proberen.",
            "emailNotInSystem": "Als je een nieuwe medewerker bent, is je e-mailadres mogelijk nog niet aan ons systeem toegevoegd. Vraag aan je beheerder wanneer je het opnieuw kan proberen.",
            "eligibleEmail": "is geen geldig e-mailadres. Heb je het goed ingevoerd?"
        }
    },
    "oneMember": "1 lid",
    "programCode": {
        "infoModal": {
            "unique": "Je bedrijf heeft een unieke programmacode die je gewoonlijk per e-mail ontvangt.",
            "support": "Als je jouw code niet kunt vinden, neem dan contact op met de beheerder van je welzijnsprogramma of stuur een e-mail aan support@sproutatwork.com met je bedrijfsnaam."
        },
        "instructions": "Voer de programmacode in die je van je werkgever hebt ontvangen om aan de slag te gaan"
    },
    "whatsMyProgramCode": "Wat is mijn programmacode?",
    "enjoyApp": "Gebruik onze mobiele app",
    "programCodeLabel": "Programmacode",
    "createdByMembersChallenges": "Gemaakt door leden",
    "invites": "Uitnodigingen",
    "recommendedContentTitle": "Keuzes voor jou uit de bibliotheek",
    "amountExchanged": "Uitgewisseld bedrag",
    "orderStatus": "Bestelstatus",
    "orderSuccessfulyyItemForConfirmation": "Bestelling gelukt! Er is een bevestigingsmail verzonden naar %{email}.",
    "orderedOnDateText": "Besteld op %{orderCreatedTime}",
    "personalize": {
        "communities": {
            "title": "Sluit je aan bij gemeenschappen",
            "description": "Gemeenschappen brengen mensen met dezelfde interesses bij elkaar. Je kunt je op elk moment aan- of afmelden bij een gemeenschap."
        },
        "objectives": {
            "title": "Mijn doelstellingen",
            "description": "Hoe kunnen we je helpen? We gebruiken de aanbevelingen om beter te worden."
        },
        "topics": {
            "title": "Mijn welzijnsonderwerpen",
            "description": "Meer tips en aanwijzingen over deze selecties."
        }
    },
    "recommendedCardDesc": "Stel maximum 3 doelen om op te focussen om je welzijn te verbeteren",
    "accessibility": {
        "track_activity": "Activiteiten traceren",
        "cardbody": "Card Body",
        "cardcontainer": "Card Container",
        "cardfooter": "Card Footer",
        "unstartedChallengeHeader": "Niet gestarte uitdaging",
        "activeOrEndedChallengeWrapper": "Uitdaging Wrapper",
        "activeOrEndedChallengeHeader": "Uitdaging Header",
        "goalHeader": "Doel Header",
        "openOptions": "Opties openen"
    },
    "teams": {
        "teamInvites": "Teamuitnodigingen",
        "findTeam": "Vind een team",
        "teamFull": "Team is vol"
    },
    "deleteAccountText": "Verwijder definitief je Sprout At Work-account en alle gegevens daarin",
    "deleteAccountButtonTitle": "Verwijder mijn account",
    "joinTeamActionSheetText": "Sluit je aan bij een team of maak je eigen team om mee te doen aan deze uitnodiging",
    "frequencyNone": "geen",
    "quickLinkTitle": "Snelle koppelingen",
    "moreTab": "Meer",
    "addedBy": "Toegevoegd door %{companyName}",
    "teamsTitle": "Teams",
    "helpAndSupport": "Hulp en ondersteuning in de app",
    "feedbackTitle": "Laat feedback achter",
    "feedbackDescription": "Laat ons weten wat je leuk vindt aan de app en wat we kunnen verbeteren.",
    "leaveTeamAction": "Verlaat het team",
    "teamActions": "Teamactiviteiten",
    "leaveTeamLeaveChallenge": "Als je dit team verlaat, doe je niet meer mee aan de uitdaging. Je moet je bij een team aansluiten om mee te blijven doen.",
    "familyMembers": "Familieleden",
    "familyMembersDescription": "Familieleden moeten ouder dan 16 jaar zijn. Ze krijgen volledige toegang en zichtbaarheid op het hele platform.",
    "learnMoreButton": "Meer informatie",
    "thvcSelection": {
        "signUpUsingTelus": "Meld je aan met je TELUS gezondheid virtuele kaart-account",
        "loginGetStarted": "Log in op Virtuele Zorg om te beginnen",
        "haveAccount": "Heb je een Virtuele Zorg-account?",
        "emailHelp": "Hulp nodig? Neem contact op met ons ondersteuningsteam op",
        "yes": "Ja",
        "signMeUp": "Nee, meld me aan"
    },
    "inviteFamilyMember": {
        "label": "Familielid uitnodigen",
        "btn": "Uitnodiging verzenden",
        "email": "E-mailadres*",
        "firstName": "Voornaam*",
        "lastName": "Achternaam*",
        "approval": "Ik bevestig dat ik toestemming heb om dit familielid uit te nodigen voor %{company}",
        "multiSelect1": "Is dit familielid in jouw regio meerderjarig?",
        "multiSelect2": "Is dit familielid ten minste 16 jaar oud?",
        "confirmTermsPolicy": "Ik bevestig dat ik de wettelijke verzorger van deze persoon ben. Naar mijn mening is de betrokken persoon volwassen genoeg om in te stemmen met het gebruik van het platform en ik ga ermee akkoord dat hij\/zij zich aansluit. Ik zal de betrokken persoon inlichten over verantwoordelijk gedrag op het platform en de manier waarop het platform gegevens verzamelt en gebruikt.",
        "onTheirBehalf": "namens hem\/haar.",
        "confirm": "Ja, ik bevestig het bovenstaande",
        "warning": "Familielid moet ten minste 16 jaar oud zijn om zich aan te melden",
        "errorMsg": "Corrigeer fouten voor je verder gaat"
    },
    "deleteFamilyMember": {
        "desc": "De account van een familielid verwijderen is definitief.",
        "btn": "Familielid verwijderen",
        "confirmation": {
            "title": "Familielid verwijderd",
            "desc": "Account van %{fullName} is verwijderd"
        },
        "areYouSure": "Weet je zeker dat je de account van %{fullName} wilt verwijderen?"
    },
    "familyInvitationStatus": {
        "active": "Actief",
        "sent": "Uitnodiging verzonden"
    },
    "familyInvitationSent": {
        "title": "Uitnodigingsmail verzonden",
        "desc": "Uitnodiging verzonden naar %{fullName}"
    },
    "programCodeSignup": "Gebruik de %{programCodeLabel} % {programCode} na klikken op '%{signUpLabel}'",
    "notJoinedCommunityLabel": "Sluit je aan bij deze gemeenschap en zie wat de leden delen",
    "moda": {
        "installApp": {
            "title": "Let op: Moda Health-leden hebben alleen toegang tot Sprout at Work via hun ledendashboard.",
            "subtitle": "Gebruik Sprout at Work op je smartphone:",
            "stepOneA": "1. Installeer de mobiele app Sprout at Work.",
            "stepOneB": "Meld u niet aan of log niet in via de mobiele app.",
            "stepTwo": "2. Meld u aan bij uw ledendashboard op uw mobiele telefoon",
            "stepThree": "3. Ga naar het Sprout-wellnessprogramma en volg de link. De mobiele app Sprout at Work zou nu geopend moeten worden."
        }
    },
    "HRISLocationSelection": {
        "title": "Vanuit welk land werk je?"
    },
    "visibilitySettings": {
        "title": "Zichtbaarheidsinstellingen",
        "desc1": "Is het oké om zichtbaar te zijn voor andere Wellbeing app-leden in uw bedrijf?",
        "desc2": "Je kunt dit later altijd nog wijzigen.",
        "moreTextQ1": "Wat kunnen andere mensen zien?",
        "moreTextAnswer1": "Uw naam, profielfoto en basisprofielgegevens (zoals afdeling en locatie) zijn zichtbaar voor mensen in uw bedrijf. Dit maakt de app socialer en leuker.",
        "moreTextQ2": "Waar verschijn ik?",
        "moreTextAnswer2": "Je wordt als deelnemer weergegeven voor uitdagingen, communities en evenementen waaraan je deelneemt, in klassementen en in zoekresultaten. Dit kun je later aanpassen.",
        "moreTextAnswer3": "We delen of tonen uw persoonlijke gezondheidsinformatie niet, zoals uw lengte, gewicht of de activiteit die u bijhoudt.",
        "btnAgree": "Het is oké om het mij te laten zien",
        "btnDisagree": "Zorg ervoor dat andere leden mij niet kunnen zien"
    },
    "privacyPolicyReadMore": "Lees ons privacybeleid voor meer informatie",
    "tellMeMore": "Vertel me meer",
    "helpUsImprove": {
        "title": "Help ons verbeteren",
        "desc1": "Wij gebruiken tools die anonieme gebruiksgegevens registreren. Door trends te zien in wat mensen bekijken en klikken, kunnen we de app beter maken.",
        "desc2": "U kunt dit op elk gewenst moment uitschakelen.",
        "moreTextQ1": "Waar we naar kijken",
        "moreTextAnswer1": "We zijn geïnteresseerd in algemene trends en statistieken, dus we kijken niet naar gegevens op individueel niveau.",
        "moreTextQ2": "Wij delen uw gegevens niet",
        "moreTextAnswer2": "Deze gegevens zijn alleen beschikbaar voor de mensen die deze app bouwen om deze te helpen verbeteren. We delen het niet met andere bedrijven, inclusief uw werkgever.",
        "moreTextQ3": "Uw gegevens zijn anoniem",
        "moreTextAnswer3": "Onze tools registreren uw naam, exacte locatie of persoonlijke gezondheidsinformatie niet.",
        "btnAgree": "Volg mijn verbruik anoniem",
        "btnDisagree": "Ik ga niet akkoord met tracking"
    },
    "deleteAccountTextAppName": "Verwijder uw %{appName}-account en alle bijbehorende gegevens definitief",
    "anonymousMember": "Anoniem lid",
    "activitiesToTrack": {
        "title": "Activiteiten om bij te houden"
    },
    "includedInMembership": "Inbegrepen in uw lidmaatschap",
    "invalidDate": "Ongeldige datum",
    "discardsStreamPost": {
        "discardTitle": "Bericht weggooien?",
        "discardChangesTitle": "Wijzigingen weggooien?",
        "discardPostText": "Weet je zeker dat je je bericht wilt verwijderen?",
        "discardPostChangesText": "Weet u zeker dat u uw wijzigingen wilt verwijderen?"
    },
    "trackActivityModalTitle": "Volg voor %{date}",
    "noPosts": "Geen berichten te zien",
    "goalIcon": "Doelpictogram",
    "resetsOn": "Resetten op %{date}",
    "clickForHelp": "Klik hier voor hulp",
    "trackActivityInputLabel": "Voer %{unit} %{activityName} %{dateFormat} in",
    "itemsFound": "Artikelen gevonden",
    "tagState": {
        "active": "Actief",
        "notActive": "Niet actief"
    },
    "bonusCheckmarkLabel": "%{bonusLabel} bonuspunten ontvangen voor voltooiing",
    "searchBar": {
        "searching": "%{term} zoeken",
        "result": "zoekresultaten"
    },
    "activityProgress": "Activiteitsvoortgang - %{levelName} %{percentFilled}% - Resets over %{daysLeft} dagen",
    "bookmark": {
        "remove": "Verwijderen uit opgeslagen items",
        "save": "Bewaar dit artikel"
    },
    "bonusMark": {
        "earn": "Verdien %{aantal} %{punten}",
        "earned": "Je hebt %{qty} %{punten} verdiend"
    },
    "tabToTrackActivity": "Tik om activiteit bij te houden",
    "videoElementLabel": "%{title}, duur %{duration}, dubbeltik om video af te spelen",
    "updatedPoliciesPopup": {
        "title": "We hebben onze voorwaarden bijgewerkt",
        "details": "We raden u aan ons bijgewerkte beleid hieronder te lezen:",
        "disclaimer": "Door op de onderstaande knop te klikken, gaat u akkoord met en erkent u het bijgewerkte beleid.",
        "agree": "Ik ben het ermee eens"
    },
    "editActivityLog": {
        "canNotEditItem": "Je kunt dit item niet bewerken",
        "canNotEditItemDescription": "Bewerken is niet beschikbaar voor activiteiten die zijn gesynchroniseerd vanaf apparaten of apps.",
        "updatedItem": "Activiteit bijgewerkt",
        "updatedItemDescription": "Uw wijzigingen zijn opgeslagen."
    },
    "login_with_email": "Inloggen met e-mail",
    "healthconnect_not_available": "Kan geen verbinding maken met Health Connect. Controleer in de Health Connect-app of de machtigingen zijn ingeschakeld.",
    "registrationField": {
        "required": {
            "firstName": "Voer uw voornaam in",
            "lastName": "Vul uw achternaam in",
            "email": "Voer een geldig e-mailadres in",
            "password": "Voer een geldig wachtwoord in"
        }
    },
    "settingsErrorMessage": {
        "firstName": "Voer uw voornaam in",
        "lastName": "Voer uw achternaam in"
    },
    "requiredValidValue": "Voer een geldige waarde in voor uw %{value}",
    "passwordHidden": "Wachtwoord verborgen, tik om het wachtwoord weer te geven",
    "passwordShown": "Wachtwoord weergegeven, tik om het wachtwoord te verbergen",
    "libraryHeaderContent": {
        "category": "",
        "points": "Verdien %{points} punten."
    },
    "scoreCurrentPeriod": "%{text} loopt van %{startDate} tot %{endDate}",
    "scoreCurrent": "%{text} is %{points} punten",
    "abbotResetPasswordModal": {
        "title": "Probeert u toegang te krijgen tot een account van vorig jaar?",
        "text": " Als je je vorig jaar hebt aangemeld voor de uitdaging, werkt dat account niet meer. Voor dit jaar moet u zich aanmelden.",
        "goToResetPasswordBtn": "Ik heb me aangemeld in %{currentYear}",
        "goToSignupBtn": "Ik heb me niet aangemeld in %{currentYear}"
    },
    "challengeRegistrationClosed": "Registratie gesloten - Challenge is gestart"
};